/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LostPasswordRouteImport } from './routes/lost-password'
import { Route as LostLoginRouteImport } from './routes/lost-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DemoPozvankaRouteImport } from './routes/demo-pozvanka'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminTestRouteImport } from './routes/admin/test'
import { Route as AdminTasksRouteImport } from './routes/admin/tasks'
import { Route as AdminSecurityGroupsRouteImport } from './routes/admin/security-groups'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminProductImagesRouteImport } from './routes/admin/product-images'
import { Route as AdminElasticRouteImport } from './routes/admin/elastic'
import { Route as AdminDemoInvitationsRouteImport } from './routes/admin/demo-invitations'
import { Route as AdminCategoryTreeRouteImport } from './routes/admin/category-tree'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminCatalogRouteImport } from './routes/admin/catalog'
import { Route as AdminBlockedCategoriesRouteImport } from './routes/admin/blocked-categories'
import { Route as ScheduledOrderActionCodeIndexRouteImport } from './routes/scheduled-order-action/$code/index'
import { Route as OrderActionCodeIndexRouteImport } from './routes/order-action/$code/index'
import { Route as AdminWorkflowsIndexRouteImport } from './routes/admin/workflows/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminSyncSendIndexRouteImport } from './routes/admin/sync-send/index'
import { Route as AdminSyncResultIndexRouteImport } from './routes/admin/sync-result/index'
import { Route as AdminSyncRequestsIndexRouteImport } from './routes/admin/sync-requests/index'
import { Route as AdminSyncDiffIndexRouteImport } from './routes/admin/sync-diff/index'
import { Route as AdminSyncBatchesIndexRouteImport } from './routes/admin/sync-batches/index'
import { Route as AdminSupplierReidIndexRouteImport } from './routes/admin/supplier-reid/index'
import { Route as AdminSessionsIndexRouteImport } from './routes/admin/sessions/index'
import { Route as AdminResolvedEmailsIndexRouteImport } from './routes/admin/resolved-emails/index'
import { Route as AdminReportsIndexRouteImport } from './routes/admin/reports/index'
import { Route as AdminReportingExportsIndexRouteImport } from './routes/admin/reporting-exports/index'
import { Route as AdminProductsIndexRouteImport } from './routes/admin/products/index'
import { Route as AdminPriceCorrectionIndexRouteImport } from './routes/admin/price-correction/index'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminOrganizationSyncIndexRouteImport } from './routes/admin/organization-sync/index'
import { Route as AdminOrganizationMergeIndexRouteImport } from './routes/admin/organization-merge/index'
import { Route as AdminOrdersIndexRouteImport } from './routes/admin/orders/index'
import { Route as AdminOrderExportsIndexRouteImport } from './routes/admin/order-exports/index'
import { Route as AdminNpUserSyncIndexRouteImport } from './routes/admin/np-user-sync/index'
import { Route as AdminNpLoadIndexRouteImport } from './routes/admin/np-load/index'
import { Route as AdminNpAddressSyncIndexRouteImport } from './routes/admin/np-address-sync/index'
import { Route as AdminInvoicingExportsIndexRouteImport } from './routes/admin/invoicing-exports/index'
import { Route as AdminInitialLoadIndexRouteImport } from './routes/admin/initial-load/index'
import { Route as AdminImageImportIndexRouteImport } from './routes/admin/image-import/index'
import { Route as AdminEsQueryLogsIndexRouteImport } from './routes/admin/es-query-logs/index'
import { Route as AdminEnvCheckIndexRouteImport } from './routes/admin/env-check/index'
import { Route as AdminEmailRequestsIndexRouteImport } from './routes/admin/email-requests/index'
import { Route as AdminDeliveryWindowsIndexRouteImport } from './routes/admin/delivery-windows/index'
import { Route as AdminDeliveryImportIndexRouteImport } from './routes/admin/delivery-import/index'
import { Route as AdminCustomersIndexRouteImport } from './routes/admin/customers/index'
import { Route as AdminContractGroupsIndexRouteImport } from './routes/admin/contract-groups/index'
import { Route as AdminCatalogImportIndexRouteImport } from './routes/admin/catalog-import/index'
import { Route as AdminCartsIndexRouteImport } from './routes/admin/carts/index'
import { Route as AdminAuctionsIndexRouteImport } from './routes/admin/auctions/index'
import { Route as AdminArticlesIndexRouteImport } from './routes/admin/articles/index'
import { Route as ScheduledOrderActionCodeRejectRouteImport } from './routes/scheduled-order-action/$code/reject'
import { Route as ScheduledOrderActionCodeDispatchNowRouteImport } from './routes/scheduled-order-action/$code/dispatch-now'
import { Route as ScheduledOrderActionCodeApproveRouteImport } from './routes/scheduled-order-action/$code/approve'
import { Route as OrderActionCodeRejectRouteImport } from './routes/order-action/$code/reject'
import { Route as OrderActionCodeApproveRouteImport } from './routes/order-action/$code/approve'
import { Route as AdminWorkflowsNameRouteImport } from './routes/admin/workflows/$name'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'
import { Route as AdminSyncBatchesRequestIdRouteImport } from './routes/admin/sync-batches/$requestId'
import { Route as AdminProductsProductIdRouteImport } from './routes/admin/products/$productId'
import { Route as AdminOrdersOrderIdRouteImport } from './routes/admin/orders/$orderId'
import { Route as AdminCustomersCustomerIdRouteImport } from './routes/admin/customers/$customerId'
import { Route as AdminAuctionsAuctionIdRouteImport } from './routes/admin/auctions/$auctionId'
import { Route as AdminArticlesArticleIdRouteImport } from './routes/admin/articles/$articleId'
import { Route as SOrgIdPortalIdRouteRouteImport } from './routes/s/$orgId/$portalId/route'
import { Route as COrgIdPortalIdRouteRouteImport } from './routes/c/$orgId/$portalId/route'
import { Route as SOrgIdPortalIdIndexRouteImport } from './routes/s/$orgId/$portalId/index'
import { Route as COrgIdPortalIdIndexRouteImport } from './routes/c/$orgId/$portalId/index'
import { Route as AdminOrganizationsOrganizationIdIndexRouteImport } from './routes/admin/organizations/$organizationId/index'
import { Route as SOrgIdPortalIdPricesRouteImport } from './routes/s/$orgId/$portalId/prices'
import { Route as SOrgIdPortalIdMyAccountRouteImport } from './routes/s/$orgId/$portalId/my-account'
import { Route as SOrgIdPortalIdDeliveryWindowsRouteImport } from './routes/s/$orgId/$portalId/delivery-windows'
import { Route as SOrgIdPortalIdCatalogRouteImport } from './routes/s/$orgId/$portalId/catalog'
import { Route as COrgIdPortalIdUsersRouteImport } from './routes/c/$orgId/$portalId/users'
import { Route as COrgIdPortalIdSettingsRouteImport } from './routes/c/$orgId/$portalId/settings'
import { Route as COrgIdPortalIdSearchRouteImport } from './routes/c/$orgId/$portalId/search'
import { Route as COrgIdPortalIdMyAccountRouteImport } from './routes/c/$orgId/$portalId/my-account'
import { Route as COrgIdPortalIdFavouritesRouteImport } from './routes/c/$orgId/$portalId/favourites'
import { Route as COrgIdPortalIdDeliveryWindowsRouteImport } from './routes/c/$orgId/$portalId/delivery-windows'
import { Route as COrgIdPortalIdDashboardRouteImport } from './routes/c/$orgId/$portalId/dashboard'
import { Route as COrgIdPortalIdCustomSuppliersRouteImport } from './routes/c/$orgId/$portalId/custom-suppliers'
import { Route as COrgIdPortalIdCustomProductsRouteImport } from './routes/c/$orgId/$portalId/custom-products'
import { Route as COrgIdPortalIdBasketRouteImport } from './routes/c/$orgId/$portalId/basket'
import { Route as COrgIdPortalIdAddressesRouteImport } from './routes/c/$orgId/$portalId/addresses'
import { Route as SOrgIdPortalIdOrdersIndexRouteImport } from './routes/s/$orgId/$portalId/orders/index'
import { Route as COrgIdPortalIdUpcomingGoodsIndexRouteImport } from './routes/c/$orgId/$portalId/upcoming-goods/index'
import { Route as COrgIdPortalIdSupportIndexRouteImport } from './routes/c/$orgId/$portalId/support/index'
import { Route as COrgIdPortalIdShoppingListIndexRouteImport } from './routes/c/$orgId/$portalId/shopping-list/index'
import { Route as COrgIdPortalIdScheduledOrdersIndexRouteImport } from './routes/c/$orgId/$portalId/scheduled-orders/index'
import { Route as COrgIdPortalIdReportsIndexRouteImport } from './routes/c/$orgId/$portalId/reports/index'
import { Route as COrgIdPortalIdOrdersIndexRouteImport } from './routes/c/$orgId/$portalId/orders/index'
import { Route as COrgIdPortalIdOrderSuccessIndexRouteImport } from './routes/c/$orgId/$portalId/order-success/index'
import { Route as COrgIdPortalIdCatalogIndexRouteImport } from './routes/c/$orgId/$portalId/catalog/index'
import { Route as COrgIdPortalIdBasketSavingsIndexRouteImport } from './routes/c/$orgId/$portalId/basket-savings/index'
import { Route as COrgIdPortalIdAuctionsIndexRouteImport } from './routes/c/$orgId/$portalId/auctions/index'
import { Route as COrgIdPortalIdArticlesIndexRouteImport } from './routes/c/$orgId/$portalId/articles/index'
import { Route as AdminOrganizationsOrganizationIdAuctionLimitsIndexRouteImport } from './routes/admin/organizations/$organizationId/auction-limits/index'
import { Route as SOrgIdPortalIdProductsProductIdRouteImport } from './routes/s/$orgId/$portalId/products/$productId'
import { Route as SOrgIdPortalIdOrdersOrderIdRouteImport } from './routes/s/$orgId/$portalId/orders/$orderId'
import { Route as COrgIdPortalIdShoppingListShoppingListIdRouteImport } from './routes/c/$orgId/$portalId/shopping-list/$shoppingListId'
import { Route as COrgIdPortalIdScheduledOrdersScheduledOrderIdRouteImport } from './routes/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
import { Route as COrgIdPortalIdReportsReportCodeRouteImport } from './routes/c/$orgId/$portalId/reports/$reportCode'
import { Route as COrgIdPortalIdOrdersOrderIdRouteImport } from './routes/c/$orgId/$portalId/orders/$orderId'
import { Route as COrgIdPortalIdCatalogCategoryEcidRouteImport } from './routes/c/$orgId/$portalId/catalog/$categoryEcid'
import { Route as COrgIdPortalIdAuctionsAuctionIdRouteImport } from './routes/c/$orgId/$portalId/auctions/$auctionId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LostPasswordRoute = LostPasswordRouteImport.update({
  id: '/lost-password',
  path: '/lost-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LostLoginRoute = LostLoginRouteImport.update({
  id: '/lost-login',
  path: '/lost-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoPozvankaRoute = DemoPozvankaRouteImport.update({
  id: '/demo-pozvanka',
  path: '/demo-pozvanka',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTestRoute = AdminTestRouteImport.update({
  id: '/admin/test',
  path: '/admin/test',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTasksRoute = AdminTasksRouteImport.update({
  id: '/admin/tasks',
  path: '/admin/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSecurityGroupsRoute = AdminSecurityGroupsRouteImport.update({
  id: '/admin/security-groups',
  path: '/admin/security-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductImagesRoute = AdminProductImagesRouteImport.update({
  id: '/admin/product-images',
  path: '/admin/product-images',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminElasticRoute = AdminElasticRouteImport.update({
  id: '/admin/elastic',
  path: '/admin/elastic',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDemoInvitationsRoute = AdminDemoInvitationsRouteImport.update({
  id: '/admin/demo-invitations',
  path: '/admin/demo-invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCategoryTreeRoute = AdminCategoryTreeRouteImport.update({
  id: '/admin/category-tree',
  path: '/admin/category-tree',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/admin/categories',
  path: '/admin/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCatalogRoute = AdminCatalogRouteImport.update({
  id: '/admin/catalog',
  path: '/admin/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBlockedCategoriesRoute = AdminBlockedCategoriesRouteImport.update({
  id: '/admin/blocked-categories',
  path: '/admin/blocked-categories',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledOrderActionCodeIndexRoute =
  ScheduledOrderActionCodeIndexRouteImport.update({
    id: '/scheduled-order-action/$code/',
    path: '/scheduled-order-action/$code/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrderActionCodeIndexRoute = OrderActionCodeIndexRouteImport.update({
  id: '/order-action/$code/',
  path: '/order-action/$code/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkflowsIndexRoute = AdminWorkflowsIndexRouteImport.update({
  id: '/admin/workflows/',
  path: '/admin/workflows/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncSendIndexRoute = AdminSyncSendIndexRouteImport.update({
  id: '/admin/sync-send/',
  path: '/admin/sync-send/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncResultIndexRoute = AdminSyncResultIndexRouteImport.update({
  id: '/admin/sync-result/',
  path: '/admin/sync-result/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncRequestsIndexRoute = AdminSyncRequestsIndexRouteImport.update({
  id: '/admin/sync-requests/',
  path: '/admin/sync-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncDiffIndexRoute = AdminSyncDiffIndexRouteImport.update({
  id: '/admin/sync-diff/',
  path: '/admin/sync-diff/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncBatchesIndexRoute = AdminSyncBatchesIndexRouteImport.update({
  id: '/admin/sync-batches/',
  path: '/admin/sync-batches/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSupplierReidIndexRoute = AdminSupplierReidIndexRouteImport.update({
  id: '/admin/supplier-reid/',
  path: '/admin/supplier-reid/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSessionsIndexRoute = AdminSessionsIndexRouteImport.update({
  id: '/admin/sessions/',
  path: '/admin/sessions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminResolvedEmailsIndexRoute =
  AdminResolvedEmailsIndexRouteImport.update({
    id: '/admin/resolved-emails/',
    path: '/admin/resolved-emails/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/admin/reports/',
  path: '/admin/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportingExportsIndexRoute =
  AdminReportingExportsIndexRouteImport.update({
    id: '/admin/reporting-exports/',
    path: '/admin/reporting-exports/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
  id: '/admin/products/',
  path: '/admin/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPriceCorrectionIndexRoute =
  AdminPriceCorrectionIndexRouteImport.update({
    id: '/admin/price-correction/',
    path: '/admin/price-correction/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/admin/organizations/',
  path: '/admin/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationSyncIndexRoute =
  AdminOrganizationSyncIndexRouteImport.update({
    id: '/admin/organization-sync/',
    path: '/admin/organization-sync/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOrganizationMergeIndexRoute =
  AdminOrganizationMergeIndexRouteImport.update({
    id: '/admin/organization-merge/',
    path: '/admin/organization-merge/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOrdersIndexRoute = AdminOrdersIndexRouteImport.update({
  id: '/admin/orders/',
  path: '/admin/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrderExportsIndexRoute = AdminOrderExportsIndexRouteImport.update({
  id: '/admin/order-exports/',
  path: '/admin/order-exports/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNpUserSyncIndexRoute = AdminNpUserSyncIndexRouteImport.update({
  id: '/admin/np-user-sync/',
  path: '/admin/np-user-sync/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNpLoadIndexRoute = AdminNpLoadIndexRouteImport.update({
  id: '/admin/np-load/',
  path: '/admin/np-load/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNpAddressSyncIndexRoute = AdminNpAddressSyncIndexRouteImport.update({
  id: '/admin/np-address-sync/',
  path: '/admin/np-address-sync/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvoicingExportsIndexRoute =
  AdminInvoicingExportsIndexRouteImport.update({
    id: '/admin/invoicing-exports/',
    path: '/admin/invoicing-exports/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminInitialLoadIndexRoute = AdminInitialLoadIndexRouteImport.update({
  id: '/admin/initial-load/',
  path: '/admin/initial-load/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminImageImportIndexRoute = AdminImageImportIndexRouteImport.update({
  id: '/admin/image-import/',
  path: '/admin/image-import/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEsQueryLogsIndexRoute = AdminEsQueryLogsIndexRouteImport.update({
  id: '/admin/es-query-logs/',
  path: '/admin/es-query-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEnvCheckIndexRoute = AdminEnvCheckIndexRouteImport.update({
  id: '/admin/env-check/',
  path: '/admin/env-check/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailRequestsIndexRoute = AdminEmailRequestsIndexRouteImport.update({
  id: '/admin/email-requests/',
  path: '/admin/email-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDeliveryWindowsIndexRoute =
  AdminDeliveryWindowsIndexRouteImport.update({
    id: '/admin/delivery-windows/',
    path: '/admin/delivery-windows/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDeliveryImportIndexRoute =
  AdminDeliveryImportIndexRouteImport.update({
    id: '/admin/delivery-import/',
    path: '/admin/delivery-import/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/admin/customers/',
  path: '/admin/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContractGroupsIndexRoute =
  AdminContractGroupsIndexRouteImport.update({
    id: '/admin/contract-groups/',
    path: '/admin/contract-groups/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCatalogImportIndexRoute = AdminCatalogImportIndexRouteImport.update({
  id: '/admin/catalog-import/',
  path: '/admin/catalog-import/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCartsIndexRoute = AdminCartsIndexRouteImport.update({
  id: '/admin/carts/',
  path: '/admin/carts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuctionsIndexRoute = AdminAuctionsIndexRouteImport.update({
  id: '/admin/auctions/',
  path: '/admin/auctions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArticlesIndexRoute = AdminArticlesIndexRouteImport.update({
  id: '/admin/articles/',
  path: '/admin/articles/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledOrderActionCodeRejectRoute =
  ScheduledOrderActionCodeRejectRouteImport.update({
    id: '/scheduled-order-action/$code/reject',
    path: '/scheduled-order-action/$code/reject',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScheduledOrderActionCodeDispatchNowRoute =
  ScheduledOrderActionCodeDispatchNowRouteImport.update({
    id: '/scheduled-order-action/$code/dispatch-now',
    path: '/scheduled-order-action/$code/dispatch-now',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScheduledOrderActionCodeApproveRoute =
  ScheduledOrderActionCodeApproveRouteImport.update({
    id: '/scheduled-order-action/$code/approve',
    path: '/scheduled-order-action/$code/approve',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrderActionCodeRejectRoute = OrderActionCodeRejectRouteImport.update({
  id: '/order-action/$code/reject',
  path: '/order-action/$code/reject',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderActionCodeApproveRoute = OrderActionCodeApproveRouteImport.update({
  id: '/order-action/$code/approve',
  path: '/order-action/$code/approve',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkflowsNameRoute = AdminWorkflowsNameRouteImport.update({
  id: '/admin/workflows/$name',
  path: '/admin/workflows/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncBatchesRequestIdRoute =
  AdminSyncBatchesRequestIdRouteImport.update({
    id: '/admin/sync-batches/$requestId',
    path: '/admin/sync-batches/$requestId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminProductsProductIdRoute = AdminProductsProductIdRouteImport.update({
  id: '/admin/products/$productId',
  path: '/admin/products/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrdersOrderIdRoute = AdminOrdersOrderIdRouteImport.update({
  id: '/admin/orders/$orderId',
  path: '/admin/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersCustomerIdRoute =
  AdminCustomersCustomerIdRouteImport.update({
    id: '/admin/customers/$customerId',
    path: '/admin/customers/$customerId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAuctionsAuctionIdRoute = AdminAuctionsAuctionIdRouteImport.update({
  id: '/admin/auctions/$auctionId',
  path: '/admin/auctions/$auctionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArticlesArticleIdRoute = AdminArticlesArticleIdRouteImport.update({
  id: '/admin/articles/$articleId',
  path: '/admin/articles/$articleId',
  getParentRoute: () => rootRouteImport,
} as any)
const SOrgIdPortalIdRouteRoute = SOrgIdPortalIdRouteRouteImport.update({
  id: '/s/$orgId/$portalId',
  path: '/s/$orgId/$portalId',
  getParentRoute: () => rootRouteImport,
} as any)
const COrgIdPortalIdRouteRoute = COrgIdPortalIdRouteRouteImport.update({
  id: '/c/$orgId/$portalId',
  path: '/c/$orgId/$portalId',
  getParentRoute: () => rootRouteImport,
} as any)
const SOrgIdPortalIdIndexRoute = SOrgIdPortalIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SOrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdIndexRoute = COrgIdPortalIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const AdminOrganizationsOrganizationIdIndexRoute =
  AdminOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/admin/organizations/$organizationId/',
    path: '/admin/organizations/$organizationId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SOrgIdPortalIdPricesRoute = SOrgIdPortalIdPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => SOrgIdPortalIdRouteRoute,
} as any)
const SOrgIdPortalIdMyAccountRoute = SOrgIdPortalIdMyAccountRouteImport.update({
  id: '/my-account',
  path: '/my-account',
  getParentRoute: () => SOrgIdPortalIdRouteRoute,
} as any)
const SOrgIdPortalIdDeliveryWindowsRoute =
  SOrgIdPortalIdDeliveryWindowsRouteImport.update({
    id: '/delivery-windows',
    path: '/delivery-windows',
    getParentRoute: () => SOrgIdPortalIdRouteRoute,
  } as any)
const SOrgIdPortalIdCatalogRoute = SOrgIdPortalIdCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => SOrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdUsersRoute = COrgIdPortalIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdSettingsRoute = COrgIdPortalIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdSearchRoute = COrgIdPortalIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdMyAccountRoute = COrgIdPortalIdMyAccountRouteImport.update({
  id: '/my-account',
  path: '/my-account',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdFavouritesRoute =
  COrgIdPortalIdFavouritesRouteImport.update({
    id: '/favourites',
    path: '/favourites',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdDeliveryWindowsRoute =
  COrgIdPortalIdDeliveryWindowsRouteImport.update({
    id: '/delivery-windows',
    path: '/delivery-windows',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdDashboardRoute = COrgIdPortalIdDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdCustomSuppliersRoute =
  COrgIdPortalIdCustomSuppliersRouteImport.update({
    id: '/custom-suppliers',
    path: '/custom-suppliers',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdCustomProductsRoute =
  COrgIdPortalIdCustomProductsRouteImport.update({
    id: '/custom-products',
    path: '/custom-products',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdBasketRoute = COrgIdPortalIdBasketRouteImport.update({
  id: '/basket',
  path: '/basket',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const COrgIdPortalIdAddressesRoute = COrgIdPortalIdAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => COrgIdPortalIdRouteRoute,
} as any)
const SOrgIdPortalIdOrdersIndexRoute =
  SOrgIdPortalIdOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => SOrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdUpcomingGoodsIndexRoute =
  COrgIdPortalIdUpcomingGoodsIndexRouteImport.update({
    id: '/upcoming-goods/',
    path: '/upcoming-goods/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdSupportIndexRoute =
  COrgIdPortalIdSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdShoppingListIndexRoute =
  COrgIdPortalIdShoppingListIndexRouteImport.update({
    id: '/shopping-list/',
    path: '/shopping-list/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdScheduledOrdersIndexRoute =
  COrgIdPortalIdScheduledOrdersIndexRouteImport.update({
    id: '/scheduled-orders/',
    path: '/scheduled-orders/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdReportsIndexRoute =
  COrgIdPortalIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdOrdersIndexRoute =
  COrgIdPortalIdOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdOrderSuccessIndexRoute =
  COrgIdPortalIdOrderSuccessIndexRouteImport.update({
    id: '/order-success/',
    path: '/order-success/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdCatalogIndexRoute =
  COrgIdPortalIdCatalogIndexRouteImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdBasketSavingsIndexRoute =
  COrgIdPortalIdBasketSavingsIndexRouteImport.update({
    id: '/basket-savings/',
    path: '/basket-savings/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdAuctionsIndexRoute =
  COrgIdPortalIdAuctionsIndexRouteImport.update({
    id: '/auctions/',
    path: '/auctions/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdArticlesIndexRoute =
  COrgIdPortalIdArticlesIndexRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute =
  AdminOrganizationsOrganizationIdAuctionLimitsIndexRouteImport.update({
    id: '/admin/organizations/$organizationId/auction-limits/',
    path: '/admin/organizations/$organizationId/auction-limits/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SOrgIdPortalIdProductsProductIdRoute =
  SOrgIdPortalIdProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => SOrgIdPortalIdRouteRoute,
  } as any)
const SOrgIdPortalIdOrdersOrderIdRoute =
  SOrgIdPortalIdOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => SOrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdShoppingListShoppingListIdRoute =
  COrgIdPortalIdShoppingListShoppingListIdRouteImport.update({
    id: '/shopping-list/$shoppingListId',
    path: '/shopping-list/$shoppingListId',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute =
  COrgIdPortalIdScheduledOrdersScheduledOrderIdRouteImport.update({
    id: '/scheduled-orders/$scheduledOrderId',
    path: '/scheduled-orders/$scheduledOrderId',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdReportsReportCodeRoute =
  COrgIdPortalIdReportsReportCodeRouteImport.update({
    id: '/reports/$reportCode',
    path: '/reports/$reportCode',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdOrdersOrderIdRoute =
  COrgIdPortalIdOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdCatalogCategoryEcidRoute =
  COrgIdPortalIdCatalogCategoryEcidRouteImport.update({
    id: '/catalog/$categoryEcid',
    path: '/catalog/$categoryEcid',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)
const COrgIdPortalIdAuctionsAuctionIdRoute =
  COrgIdPortalIdAuctionsAuctionIdRouteImport.update({
    id: '/auctions/$auctionId',
    path: '/auctions/$auctionId',
    getParentRoute: () => COrgIdPortalIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/demo-pozvanka': typeof DemoPozvankaRoute
  '/login': typeof LoginRoute
  '/lost-login': typeof LostLoginRoute
  '/lost-password': typeof LostPasswordRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/blocked-categories': typeof AdminBlockedCategoriesRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/category-tree': typeof AdminCategoryTreeRoute
  '/admin/demo-invitations': typeof AdminDemoInvitationsRoute
  '/admin/elastic': typeof AdminElasticRoute
  '/admin/product-images': typeof AdminProductImagesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/security-groups': typeof AdminSecurityGroupsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/test': typeof AdminTestRoute
  '/admin': typeof AdminIndexRoute
  '/c/$orgId/$portalId': typeof COrgIdPortalIdRouteRouteWithChildren
  '/s/$orgId/$portalId': typeof SOrgIdPortalIdRouteRouteWithChildren
  '/admin/articles/$articleId': typeof AdminArticlesArticleIdRoute
  '/admin/auctions/$auctionId': typeof AdminAuctionsAuctionIdRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/orders/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/sync-batches/$requestId': typeof AdminSyncBatchesRequestIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/workflows/$name': typeof AdminWorkflowsNameRoute
  '/order-action/$code/approve': typeof OrderActionCodeApproveRoute
  '/order-action/$code/reject': typeof OrderActionCodeRejectRoute
  '/scheduled-order-action/$code/approve': typeof ScheduledOrderActionCodeApproveRoute
  '/scheduled-order-action/$code/dispatch-now': typeof ScheduledOrderActionCodeDispatchNowRoute
  '/scheduled-order-action/$code/reject': typeof ScheduledOrderActionCodeRejectRoute
  '/admin/articles': typeof AdminArticlesIndexRoute
  '/admin/auctions': typeof AdminAuctionsIndexRoute
  '/admin/carts': typeof AdminCartsIndexRoute
  '/admin/catalog-import': typeof AdminCatalogImportIndexRoute
  '/admin/contract-groups': typeof AdminContractGroupsIndexRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/delivery-import': typeof AdminDeliveryImportIndexRoute
  '/admin/delivery-windows': typeof AdminDeliveryWindowsIndexRoute
  '/admin/email-requests': typeof AdminEmailRequestsIndexRoute
  '/admin/env-check': typeof AdminEnvCheckIndexRoute
  '/admin/es-query-logs': typeof AdminEsQueryLogsIndexRoute
  '/admin/image-import': typeof AdminImageImportIndexRoute
  '/admin/initial-load': typeof AdminInitialLoadIndexRoute
  '/admin/invoicing-exports': typeof AdminInvoicingExportsIndexRoute
  '/admin/np-address-sync': typeof AdminNpAddressSyncIndexRoute
  '/admin/np-load': typeof AdminNpLoadIndexRoute
  '/admin/np-user-sync': typeof AdminNpUserSyncIndexRoute
  '/admin/order-exports': typeof AdminOrderExportsIndexRoute
  '/admin/orders': typeof AdminOrdersIndexRoute
  '/admin/organization-merge': typeof AdminOrganizationMergeIndexRoute
  '/admin/organization-sync': typeof AdminOrganizationSyncIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/price-correction': typeof AdminPriceCorrectionIndexRoute
  '/admin/products': typeof AdminProductsIndexRoute
  '/admin/reporting-exports': typeof AdminReportingExportsIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/admin/resolved-emails': typeof AdminResolvedEmailsIndexRoute
  '/admin/sessions': typeof AdminSessionsIndexRoute
  '/admin/supplier-reid': typeof AdminSupplierReidIndexRoute
  '/admin/sync-batches': typeof AdminSyncBatchesIndexRoute
  '/admin/sync-diff': typeof AdminSyncDiffIndexRoute
  '/admin/sync-requests': typeof AdminSyncRequestsIndexRoute
  '/admin/sync-result': typeof AdminSyncResultIndexRoute
  '/admin/sync-send': typeof AdminSyncSendIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/workflows': typeof AdminWorkflowsIndexRoute
  '/order-action/$code': typeof OrderActionCodeIndexRoute
  '/scheduled-order-action/$code': typeof ScheduledOrderActionCodeIndexRoute
  '/c/$orgId/$portalId/addresses': typeof COrgIdPortalIdAddressesRoute
  '/c/$orgId/$portalId/basket': typeof COrgIdPortalIdBasketRoute
  '/c/$orgId/$portalId/custom-products': typeof COrgIdPortalIdCustomProductsRoute
  '/c/$orgId/$portalId/custom-suppliers': typeof COrgIdPortalIdCustomSuppliersRoute
  '/c/$orgId/$portalId/dashboard': typeof COrgIdPortalIdDashboardRoute
  '/c/$orgId/$portalId/delivery-windows': typeof COrgIdPortalIdDeliveryWindowsRoute
  '/c/$orgId/$portalId/favourites': typeof COrgIdPortalIdFavouritesRoute
  '/c/$orgId/$portalId/my-account': typeof COrgIdPortalIdMyAccountRoute
  '/c/$orgId/$portalId/search': typeof COrgIdPortalIdSearchRoute
  '/c/$orgId/$portalId/settings': typeof COrgIdPortalIdSettingsRoute
  '/c/$orgId/$portalId/users': typeof COrgIdPortalIdUsersRoute
  '/s/$orgId/$portalId/catalog': typeof SOrgIdPortalIdCatalogRoute
  '/s/$orgId/$portalId/delivery-windows': typeof SOrgIdPortalIdDeliveryWindowsRoute
  '/s/$orgId/$portalId/my-account': typeof SOrgIdPortalIdMyAccountRoute
  '/s/$orgId/$portalId/prices': typeof SOrgIdPortalIdPricesRoute
  '/admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdIndexRoute
  '/c/$orgId/$portalId/': typeof COrgIdPortalIdIndexRoute
  '/s/$orgId/$portalId/': typeof SOrgIdPortalIdIndexRoute
  '/c/$orgId/$portalId/auctions/$auctionId': typeof COrgIdPortalIdAuctionsAuctionIdRoute
  '/c/$orgId/$portalId/catalog/$categoryEcid': typeof COrgIdPortalIdCatalogCategoryEcidRoute
  '/c/$orgId/$portalId/orders/$orderId': typeof COrgIdPortalIdOrdersOrderIdRoute
  '/c/$orgId/$portalId/reports/$reportCode': typeof COrgIdPortalIdReportsReportCodeRoute
  '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId': typeof COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute
  '/c/$orgId/$portalId/shopping-list/$shoppingListId': typeof COrgIdPortalIdShoppingListShoppingListIdRoute
  '/s/$orgId/$portalId/orders/$orderId': typeof SOrgIdPortalIdOrdersOrderIdRoute
  '/s/$orgId/$portalId/products/$productId': typeof SOrgIdPortalIdProductsProductIdRoute
  '/admin/organizations/$organizationId/auction-limits': typeof AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute
  '/c/$orgId/$portalId/articles': typeof COrgIdPortalIdArticlesIndexRoute
  '/c/$orgId/$portalId/auctions': typeof COrgIdPortalIdAuctionsIndexRoute
  '/c/$orgId/$portalId/basket-savings': typeof COrgIdPortalIdBasketSavingsIndexRoute
  '/c/$orgId/$portalId/catalog': typeof COrgIdPortalIdCatalogIndexRoute
  '/c/$orgId/$portalId/order-success': typeof COrgIdPortalIdOrderSuccessIndexRoute
  '/c/$orgId/$portalId/orders': typeof COrgIdPortalIdOrdersIndexRoute
  '/c/$orgId/$portalId/reports': typeof COrgIdPortalIdReportsIndexRoute
  '/c/$orgId/$portalId/scheduled-orders': typeof COrgIdPortalIdScheduledOrdersIndexRoute
  '/c/$orgId/$portalId/shopping-list': typeof COrgIdPortalIdShoppingListIndexRoute
  '/c/$orgId/$portalId/support': typeof COrgIdPortalIdSupportIndexRoute
  '/c/$orgId/$portalId/upcoming-goods': typeof COrgIdPortalIdUpcomingGoodsIndexRoute
  '/s/$orgId/$portalId/orders': typeof SOrgIdPortalIdOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/demo-pozvanka': typeof DemoPozvankaRoute
  '/login': typeof LoginRoute
  '/lost-login': typeof LostLoginRoute
  '/lost-password': typeof LostPasswordRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/blocked-categories': typeof AdminBlockedCategoriesRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/category-tree': typeof AdminCategoryTreeRoute
  '/admin/demo-invitations': typeof AdminDemoInvitationsRoute
  '/admin/elastic': typeof AdminElasticRoute
  '/admin/product-images': typeof AdminProductImagesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/security-groups': typeof AdminSecurityGroupsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/test': typeof AdminTestRoute
  '/admin': typeof AdminIndexRoute
  '/admin/articles/$articleId': typeof AdminArticlesArticleIdRoute
  '/admin/auctions/$auctionId': typeof AdminAuctionsAuctionIdRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/orders/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/sync-batches/$requestId': typeof AdminSyncBatchesRequestIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/workflows/$name': typeof AdminWorkflowsNameRoute
  '/order-action/$code/approve': typeof OrderActionCodeApproveRoute
  '/order-action/$code/reject': typeof OrderActionCodeRejectRoute
  '/scheduled-order-action/$code/approve': typeof ScheduledOrderActionCodeApproveRoute
  '/scheduled-order-action/$code/dispatch-now': typeof ScheduledOrderActionCodeDispatchNowRoute
  '/scheduled-order-action/$code/reject': typeof ScheduledOrderActionCodeRejectRoute
  '/admin/articles': typeof AdminArticlesIndexRoute
  '/admin/auctions': typeof AdminAuctionsIndexRoute
  '/admin/carts': typeof AdminCartsIndexRoute
  '/admin/catalog-import': typeof AdminCatalogImportIndexRoute
  '/admin/contract-groups': typeof AdminContractGroupsIndexRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/delivery-import': typeof AdminDeliveryImportIndexRoute
  '/admin/delivery-windows': typeof AdminDeliveryWindowsIndexRoute
  '/admin/email-requests': typeof AdminEmailRequestsIndexRoute
  '/admin/env-check': typeof AdminEnvCheckIndexRoute
  '/admin/es-query-logs': typeof AdminEsQueryLogsIndexRoute
  '/admin/image-import': typeof AdminImageImportIndexRoute
  '/admin/initial-load': typeof AdminInitialLoadIndexRoute
  '/admin/invoicing-exports': typeof AdminInvoicingExportsIndexRoute
  '/admin/np-address-sync': typeof AdminNpAddressSyncIndexRoute
  '/admin/np-load': typeof AdminNpLoadIndexRoute
  '/admin/np-user-sync': typeof AdminNpUserSyncIndexRoute
  '/admin/order-exports': typeof AdminOrderExportsIndexRoute
  '/admin/orders': typeof AdminOrdersIndexRoute
  '/admin/organization-merge': typeof AdminOrganizationMergeIndexRoute
  '/admin/organization-sync': typeof AdminOrganizationSyncIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/price-correction': typeof AdminPriceCorrectionIndexRoute
  '/admin/products': typeof AdminProductsIndexRoute
  '/admin/reporting-exports': typeof AdminReportingExportsIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/admin/resolved-emails': typeof AdminResolvedEmailsIndexRoute
  '/admin/sessions': typeof AdminSessionsIndexRoute
  '/admin/supplier-reid': typeof AdminSupplierReidIndexRoute
  '/admin/sync-batches': typeof AdminSyncBatchesIndexRoute
  '/admin/sync-diff': typeof AdminSyncDiffIndexRoute
  '/admin/sync-requests': typeof AdminSyncRequestsIndexRoute
  '/admin/sync-result': typeof AdminSyncResultIndexRoute
  '/admin/sync-send': typeof AdminSyncSendIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/workflows': typeof AdminWorkflowsIndexRoute
  '/order-action/$code': typeof OrderActionCodeIndexRoute
  '/scheduled-order-action/$code': typeof ScheduledOrderActionCodeIndexRoute
  '/c/$orgId/$portalId/addresses': typeof COrgIdPortalIdAddressesRoute
  '/c/$orgId/$portalId/basket': typeof COrgIdPortalIdBasketRoute
  '/c/$orgId/$portalId/custom-products': typeof COrgIdPortalIdCustomProductsRoute
  '/c/$orgId/$portalId/custom-suppliers': typeof COrgIdPortalIdCustomSuppliersRoute
  '/c/$orgId/$portalId/dashboard': typeof COrgIdPortalIdDashboardRoute
  '/c/$orgId/$portalId/delivery-windows': typeof COrgIdPortalIdDeliveryWindowsRoute
  '/c/$orgId/$portalId/favourites': typeof COrgIdPortalIdFavouritesRoute
  '/c/$orgId/$portalId/my-account': typeof COrgIdPortalIdMyAccountRoute
  '/c/$orgId/$portalId/search': typeof COrgIdPortalIdSearchRoute
  '/c/$orgId/$portalId/settings': typeof COrgIdPortalIdSettingsRoute
  '/c/$orgId/$portalId/users': typeof COrgIdPortalIdUsersRoute
  '/s/$orgId/$portalId/catalog': typeof SOrgIdPortalIdCatalogRoute
  '/s/$orgId/$portalId/delivery-windows': typeof SOrgIdPortalIdDeliveryWindowsRoute
  '/s/$orgId/$portalId/my-account': typeof SOrgIdPortalIdMyAccountRoute
  '/s/$orgId/$portalId/prices': typeof SOrgIdPortalIdPricesRoute
  '/admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdIndexRoute
  '/c/$orgId/$portalId': typeof COrgIdPortalIdIndexRoute
  '/s/$orgId/$portalId': typeof SOrgIdPortalIdIndexRoute
  '/c/$orgId/$portalId/auctions/$auctionId': typeof COrgIdPortalIdAuctionsAuctionIdRoute
  '/c/$orgId/$portalId/catalog/$categoryEcid': typeof COrgIdPortalIdCatalogCategoryEcidRoute
  '/c/$orgId/$portalId/orders/$orderId': typeof COrgIdPortalIdOrdersOrderIdRoute
  '/c/$orgId/$portalId/reports/$reportCode': typeof COrgIdPortalIdReportsReportCodeRoute
  '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId': typeof COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute
  '/c/$orgId/$portalId/shopping-list/$shoppingListId': typeof COrgIdPortalIdShoppingListShoppingListIdRoute
  '/s/$orgId/$portalId/orders/$orderId': typeof SOrgIdPortalIdOrdersOrderIdRoute
  '/s/$orgId/$portalId/products/$productId': typeof SOrgIdPortalIdProductsProductIdRoute
  '/admin/organizations/$organizationId/auction-limits': typeof AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute
  '/c/$orgId/$portalId/articles': typeof COrgIdPortalIdArticlesIndexRoute
  '/c/$orgId/$portalId/auctions': typeof COrgIdPortalIdAuctionsIndexRoute
  '/c/$orgId/$portalId/basket-savings': typeof COrgIdPortalIdBasketSavingsIndexRoute
  '/c/$orgId/$portalId/catalog': typeof COrgIdPortalIdCatalogIndexRoute
  '/c/$orgId/$portalId/order-success': typeof COrgIdPortalIdOrderSuccessIndexRoute
  '/c/$orgId/$portalId/orders': typeof COrgIdPortalIdOrdersIndexRoute
  '/c/$orgId/$portalId/reports': typeof COrgIdPortalIdReportsIndexRoute
  '/c/$orgId/$portalId/scheduled-orders': typeof COrgIdPortalIdScheduledOrdersIndexRoute
  '/c/$orgId/$portalId/shopping-list': typeof COrgIdPortalIdShoppingListIndexRoute
  '/c/$orgId/$portalId/support': typeof COrgIdPortalIdSupportIndexRoute
  '/c/$orgId/$portalId/upcoming-goods': typeof COrgIdPortalIdUpcomingGoodsIndexRoute
  '/s/$orgId/$portalId/orders': typeof SOrgIdPortalIdOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/change-password': typeof ChangePasswordRoute
  '/demo-pozvanka': typeof DemoPozvankaRoute
  '/login': typeof LoginRoute
  '/lost-login': typeof LostLoginRoute
  '/lost-password': typeof LostPasswordRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin/blocked-categories': typeof AdminBlockedCategoriesRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/category-tree': typeof AdminCategoryTreeRoute
  '/admin/demo-invitations': typeof AdminDemoInvitationsRoute
  '/admin/elastic': typeof AdminElasticRoute
  '/admin/product-images': typeof AdminProductImagesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/security-groups': typeof AdminSecurityGroupsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/test': typeof AdminTestRoute
  '/admin/': typeof AdminIndexRoute
  '/c/$orgId/$portalId': typeof COrgIdPortalIdRouteRouteWithChildren
  '/s/$orgId/$portalId': typeof SOrgIdPortalIdRouteRouteWithChildren
  '/admin/articles/$articleId': typeof AdminArticlesArticleIdRoute
  '/admin/auctions/$auctionId': typeof AdminAuctionsAuctionIdRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/orders/$orderId': typeof AdminOrdersOrderIdRoute
  '/admin/products/$productId': typeof AdminProductsProductIdRoute
  '/admin/sync-batches/$requestId': typeof AdminSyncBatchesRequestIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/workflows/$name': typeof AdminWorkflowsNameRoute
  '/order-action/$code/approve': typeof OrderActionCodeApproveRoute
  '/order-action/$code/reject': typeof OrderActionCodeRejectRoute
  '/scheduled-order-action/$code/approve': typeof ScheduledOrderActionCodeApproveRoute
  '/scheduled-order-action/$code/dispatch-now': typeof ScheduledOrderActionCodeDispatchNowRoute
  '/scheduled-order-action/$code/reject': typeof ScheduledOrderActionCodeRejectRoute
  '/admin/articles/': typeof AdminArticlesIndexRoute
  '/admin/auctions/': typeof AdminAuctionsIndexRoute
  '/admin/carts/': typeof AdminCartsIndexRoute
  '/admin/catalog-import/': typeof AdminCatalogImportIndexRoute
  '/admin/contract-groups/': typeof AdminContractGroupsIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/delivery-import/': typeof AdminDeliveryImportIndexRoute
  '/admin/delivery-windows/': typeof AdminDeliveryWindowsIndexRoute
  '/admin/email-requests/': typeof AdminEmailRequestsIndexRoute
  '/admin/env-check/': typeof AdminEnvCheckIndexRoute
  '/admin/es-query-logs/': typeof AdminEsQueryLogsIndexRoute
  '/admin/image-import/': typeof AdminImageImportIndexRoute
  '/admin/initial-load/': typeof AdminInitialLoadIndexRoute
  '/admin/invoicing-exports/': typeof AdminInvoicingExportsIndexRoute
  '/admin/np-address-sync/': typeof AdminNpAddressSyncIndexRoute
  '/admin/np-load/': typeof AdminNpLoadIndexRoute
  '/admin/np-user-sync/': typeof AdminNpUserSyncIndexRoute
  '/admin/order-exports/': typeof AdminOrderExportsIndexRoute
  '/admin/orders/': typeof AdminOrdersIndexRoute
  '/admin/organization-merge/': typeof AdminOrganizationMergeIndexRoute
  '/admin/organization-sync/': typeof AdminOrganizationSyncIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/price-correction/': typeof AdminPriceCorrectionIndexRoute
  '/admin/products/': typeof AdminProductsIndexRoute
  '/admin/reporting-exports/': typeof AdminReportingExportsIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/resolved-emails/': typeof AdminResolvedEmailsIndexRoute
  '/admin/sessions/': typeof AdminSessionsIndexRoute
  '/admin/supplier-reid/': typeof AdminSupplierReidIndexRoute
  '/admin/sync-batches/': typeof AdminSyncBatchesIndexRoute
  '/admin/sync-diff/': typeof AdminSyncDiffIndexRoute
  '/admin/sync-requests/': typeof AdminSyncRequestsIndexRoute
  '/admin/sync-result/': typeof AdminSyncResultIndexRoute
  '/admin/sync-send/': typeof AdminSyncSendIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/workflows/': typeof AdminWorkflowsIndexRoute
  '/order-action/$code/': typeof OrderActionCodeIndexRoute
  '/scheduled-order-action/$code/': typeof ScheduledOrderActionCodeIndexRoute
  '/c/$orgId/$portalId/addresses': typeof COrgIdPortalIdAddressesRoute
  '/c/$orgId/$portalId/basket': typeof COrgIdPortalIdBasketRoute
  '/c/$orgId/$portalId/custom-products': typeof COrgIdPortalIdCustomProductsRoute
  '/c/$orgId/$portalId/custom-suppliers': typeof COrgIdPortalIdCustomSuppliersRoute
  '/c/$orgId/$portalId/dashboard': typeof COrgIdPortalIdDashboardRoute
  '/c/$orgId/$portalId/delivery-windows': typeof COrgIdPortalIdDeliveryWindowsRoute
  '/c/$orgId/$portalId/favourites': typeof COrgIdPortalIdFavouritesRoute
  '/c/$orgId/$portalId/my-account': typeof COrgIdPortalIdMyAccountRoute
  '/c/$orgId/$portalId/search': typeof COrgIdPortalIdSearchRoute
  '/c/$orgId/$portalId/settings': typeof COrgIdPortalIdSettingsRoute
  '/c/$orgId/$portalId/users': typeof COrgIdPortalIdUsersRoute
  '/s/$orgId/$portalId/catalog': typeof SOrgIdPortalIdCatalogRoute
  '/s/$orgId/$portalId/delivery-windows': typeof SOrgIdPortalIdDeliveryWindowsRoute
  '/s/$orgId/$portalId/my-account': typeof SOrgIdPortalIdMyAccountRoute
  '/s/$orgId/$portalId/prices': typeof SOrgIdPortalIdPricesRoute
  '/admin/organizations/$organizationId/': typeof AdminOrganizationsOrganizationIdIndexRoute
  '/c/$orgId/$portalId/': typeof COrgIdPortalIdIndexRoute
  '/s/$orgId/$portalId/': typeof SOrgIdPortalIdIndexRoute
  '/c/$orgId/$portalId/auctions/$auctionId': typeof COrgIdPortalIdAuctionsAuctionIdRoute
  '/c/$orgId/$portalId/catalog/$categoryEcid': typeof COrgIdPortalIdCatalogCategoryEcidRoute
  '/c/$orgId/$portalId/orders/$orderId': typeof COrgIdPortalIdOrdersOrderIdRoute
  '/c/$orgId/$portalId/reports/$reportCode': typeof COrgIdPortalIdReportsReportCodeRoute
  '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId': typeof COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute
  '/c/$orgId/$portalId/shopping-list/$shoppingListId': typeof COrgIdPortalIdShoppingListShoppingListIdRoute
  '/s/$orgId/$portalId/orders/$orderId': typeof SOrgIdPortalIdOrdersOrderIdRoute
  '/s/$orgId/$portalId/products/$productId': typeof SOrgIdPortalIdProductsProductIdRoute
  '/admin/organizations/$organizationId/auction-limits/': typeof AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute
  '/c/$orgId/$portalId/articles/': typeof COrgIdPortalIdArticlesIndexRoute
  '/c/$orgId/$portalId/auctions/': typeof COrgIdPortalIdAuctionsIndexRoute
  '/c/$orgId/$portalId/basket-savings/': typeof COrgIdPortalIdBasketSavingsIndexRoute
  '/c/$orgId/$portalId/catalog/': typeof COrgIdPortalIdCatalogIndexRoute
  '/c/$orgId/$portalId/order-success/': typeof COrgIdPortalIdOrderSuccessIndexRoute
  '/c/$orgId/$portalId/orders/': typeof COrgIdPortalIdOrdersIndexRoute
  '/c/$orgId/$portalId/reports/': typeof COrgIdPortalIdReportsIndexRoute
  '/c/$orgId/$portalId/scheduled-orders/': typeof COrgIdPortalIdScheduledOrdersIndexRoute
  '/c/$orgId/$portalId/shopping-list/': typeof COrgIdPortalIdShoppingListIndexRoute
  '/c/$orgId/$portalId/support/': typeof COrgIdPortalIdSupportIndexRoute
  '/c/$orgId/$portalId/upcoming-goods/': typeof COrgIdPortalIdUpcomingGoodsIndexRoute
  '/s/$orgId/$portalId/orders/': typeof SOrgIdPortalIdOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/change-password'
    | '/demo-pozvanka'
    | '/login'
    | '/lost-login'
    | '/lost-password'
    | '/profile'
    | '/reset-password'
    | '/admin/blocked-categories'
    | '/admin/catalog'
    | '/admin/categories'
    | '/admin/category-tree'
    | '/admin/demo-invitations'
    | '/admin/elastic'
    | '/admin/product-images'
    | '/admin/roles'
    | '/admin/security-groups'
    | '/admin/tasks'
    | '/admin/test'
    | '/admin'
    | '/c/$orgId/$portalId'
    | '/s/$orgId/$portalId'
    | '/admin/articles/$articleId'
    | '/admin/auctions/$auctionId'
    | '/admin/customers/$customerId'
    | '/admin/orders/$orderId'
    | '/admin/products/$productId'
    | '/admin/sync-batches/$requestId'
    | '/admin/users/$userId'
    | '/admin/workflows/$name'
    | '/order-action/$code/approve'
    | '/order-action/$code/reject'
    | '/scheduled-order-action/$code/approve'
    | '/scheduled-order-action/$code/dispatch-now'
    | '/scheduled-order-action/$code/reject'
    | '/admin/articles'
    | '/admin/auctions'
    | '/admin/carts'
    | '/admin/catalog-import'
    | '/admin/contract-groups'
    | '/admin/customers'
    | '/admin/delivery-import'
    | '/admin/delivery-windows'
    | '/admin/email-requests'
    | '/admin/env-check'
    | '/admin/es-query-logs'
    | '/admin/image-import'
    | '/admin/initial-load'
    | '/admin/invoicing-exports'
    | '/admin/np-address-sync'
    | '/admin/np-load'
    | '/admin/np-user-sync'
    | '/admin/order-exports'
    | '/admin/orders'
    | '/admin/organization-merge'
    | '/admin/organization-sync'
    | '/admin/organizations'
    | '/admin/price-correction'
    | '/admin/products'
    | '/admin/reporting-exports'
    | '/admin/reports'
    | '/admin/resolved-emails'
    | '/admin/sessions'
    | '/admin/supplier-reid'
    | '/admin/sync-batches'
    | '/admin/sync-diff'
    | '/admin/sync-requests'
    | '/admin/sync-result'
    | '/admin/sync-send'
    | '/admin/users'
    | '/admin/workflows'
    | '/order-action/$code'
    | '/scheduled-order-action/$code'
    | '/c/$orgId/$portalId/addresses'
    | '/c/$orgId/$portalId/basket'
    | '/c/$orgId/$portalId/custom-products'
    | '/c/$orgId/$portalId/custom-suppliers'
    | '/c/$orgId/$portalId/dashboard'
    | '/c/$orgId/$portalId/delivery-windows'
    | '/c/$orgId/$portalId/favourites'
    | '/c/$orgId/$portalId/my-account'
    | '/c/$orgId/$portalId/search'
    | '/c/$orgId/$portalId/settings'
    | '/c/$orgId/$portalId/users'
    | '/s/$orgId/$portalId/catalog'
    | '/s/$orgId/$portalId/delivery-windows'
    | '/s/$orgId/$portalId/my-account'
    | '/s/$orgId/$portalId/prices'
    | '/admin/organizations/$organizationId'
    | '/c/$orgId/$portalId/'
    | '/s/$orgId/$portalId/'
    | '/c/$orgId/$portalId/auctions/$auctionId'
    | '/c/$orgId/$portalId/catalog/$categoryEcid'
    | '/c/$orgId/$portalId/orders/$orderId'
    | '/c/$orgId/$portalId/reports/$reportCode'
    | '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
    | '/c/$orgId/$portalId/shopping-list/$shoppingListId'
    | '/s/$orgId/$portalId/orders/$orderId'
    | '/s/$orgId/$portalId/products/$productId'
    | '/admin/organizations/$organizationId/auction-limits'
    | '/c/$orgId/$portalId/articles'
    | '/c/$orgId/$portalId/auctions'
    | '/c/$orgId/$portalId/basket-savings'
    | '/c/$orgId/$portalId/catalog'
    | '/c/$orgId/$portalId/order-success'
    | '/c/$orgId/$portalId/orders'
    | '/c/$orgId/$portalId/reports'
    | '/c/$orgId/$portalId/scheduled-orders'
    | '/c/$orgId/$portalId/shopping-list'
    | '/c/$orgId/$portalId/support'
    | '/c/$orgId/$portalId/upcoming-goods'
    | '/s/$orgId/$portalId/orders'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/change-password'
    | '/demo-pozvanka'
    | '/login'
    | '/lost-login'
    | '/lost-password'
    | '/profile'
    | '/reset-password'
    | '/admin/blocked-categories'
    | '/admin/catalog'
    | '/admin/categories'
    | '/admin/category-tree'
    | '/admin/demo-invitations'
    | '/admin/elastic'
    | '/admin/product-images'
    | '/admin/roles'
    | '/admin/security-groups'
    | '/admin/tasks'
    | '/admin/test'
    | '/admin'
    | '/admin/articles/$articleId'
    | '/admin/auctions/$auctionId'
    | '/admin/customers/$customerId'
    | '/admin/orders/$orderId'
    | '/admin/products/$productId'
    | '/admin/sync-batches/$requestId'
    | '/admin/users/$userId'
    | '/admin/workflows/$name'
    | '/order-action/$code/approve'
    | '/order-action/$code/reject'
    | '/scheduled-order-action/$code/approve'
    | '/scheduled-order-action/$code/dispatch-now'
    | '/scheduled-order-action/$code/reject'
    | '/admin/articles'
    | '/admin/auctions'
    | '/admin/carts'
    | '/admin/catalog-import'
    | '/admin/contract-groups'
    | '/admin/customers'
    | '/admin/delivery-import'
    | '/admin/delivery-windows'
    | '/admin/email-requests'
    | '/admin/env-check'
    | '/admin/es-query-logs'
    | '/admin/image-import'
    | '/admin/initial-load'
    | '/admin/invoicing-exports'
    | '/admin/np-address-sync'
    | '/admin/np-load'
    | '/admin/np-user-sync'
    | '/admin/order-exports'
    | '/admin/orders'
    | '/admin/organization-merge'
    | '/admin/organization-sync'
    | '/admin/organizations'
    | '/admin/price-correction'
    | '/admin/products'
    | '/admin/reporting-exports'
    | '/admin/reports'
    | '/admin/resolved-emails'
    | '/admin/sessions'
    | '/admin/supplier-reid'
    | '/admin/sync-batches'
    | '/admin/sync-diff'
    | '/admin/sync-requests'
    | '/admin/sync-result'
    | '/admin/sync-send'
    | '/admin/users'
    | '/admin/workflows'
    | '/order-action/$code'
    | '/scheduled-order-action/$code'
    | '/c/$orgId/$portalId/addresses'
    | '/c/$orgId/$portalId/basket'
    | '/c/$orgId/$portalId/custom-products'
    | '/c/$orgId/$portalId/custom-suppliers'
    | '/c/$orgId/$portalId/dashboard'
    | '/c/$orgId/$portalId/delivery-windows'
    | '/c/$orgId/$portalId/favourites'
    | '/c/$orgId/$portalId/my-account'
    | '/c/$orgId/$portalId/search'
    | '/c/$orgId/$portalId/settings'
    | '/c/$orgId/$portalId/users'
    | '/s/$orgId/$portalId/catalog'
    | '/s/$orgId/$portalId/delivery-windows'
    | '/s/$orgId/$portalId/my-account'
    | '/s/$orgId/$portalId/prices'
    | '/admin/organizations/$organizationId'
    | '/c/$orgId/$portalId'
    | '/s/$orgId/$portalId'
    | '/c/$orgId/$portalId/auctions/$auctionId'
    | '/c/$orgId/$portalId/catalog/$categoryEcid'
    | '/c/$orgId/$portalId/orders/$orderId'
    | '/c/$orgId/$portalId/reports/$reportCode'
    | '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
    | '/c/$orgId/$portalId/shopping-list/$shoppingListId'
    | '/s/$orgId/$portalId/orders/$orderId'
    | '/s/$orgId/$portalId/products/$productId'
    | '/admin/organizations/$organizationId/auction-limits'
    | '/c/$orgId/$portalId/articles'
    | '/c/$orgId/$portalId/auctions'
    | '/c/$orgId/$portalId/basket-savings'
    | '/c/$orgId/$portalId/catalog'
    | '/c/$orgId/$portalId/order-success'
    | '/c/$orgId/$portalId/orders'
    | '/c/$orgId/$portalId/reports'
    | '/c/$orgId/$portalId/scheduled-orders'
    | '/c/$orgId/$portalId/shopping-list'
    | '/c/$orgId/$portalId/support'
    | '/c/$orgId/$portalId/upcoming-goods'
    | '/s/$orgId/$portalId/orders'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/change-password'
    | '/demo-pozvanka'
    | '/login'
    | '/lost-login'
    | '/lost-password'
    | '/profile'
    | '/reset-password'
    | '/admin/blocked-categories'
    | '/admin/catalog'
    | '/admin/categories'
    | '/admin/category-tree'
    | '/admin/demo-invitations'
    | '/admin/elastic'
    | '/admin/product-images'
    | '/admin/roles'
    | '/admin/security-groups'
    | '/admin/tasks'
    | '/admin/test'
    | '/admin/'
    | '/c/$orgId/$portalId'
    | '/s/$orgId/$portalId'
    | '/admin/articles/$articleId'
    | '/admin/auctions/$auctionId'
    | '/admin/customers/$customerId'
    | '/admin/orders/$orderId'
    | '/admin/products/$productId'
    | '/admin/sync-batches/$requestId'
    | '/admin/users/$userId'
    | '/admin/workflows/$name'
    | '/order-action/$code/approve'
    | '/order-action/$code/reject'
    | '/scheduled-order-action/$code/approve'
    | '/scheduled-order-action/$code/dispatch-now'
    | '/scheduled-order-action/$code/reject'
    | '/admin/articles/'
    | '/admin/auctions/'
    | '/admin/carts/'
    | '/admin/catalog-import/'
    | '/admin/contract-groups/'
    | '/admin/customers/'
    | '/admin/delivery-import/'
    | '/admin/delivery-windows/'
    | '/admin/email-requests/'
    | '/admin/env-check/'
    | '/admin/es-query-logs/'
    | '/admin/image-import/'
    | '/admin/initial-load/'
    | '/admin/invoicing-exports/'
    | '/admin/np-address-sync/'
    | '/admin/np-load/'
    | '/admin/np-user-sync/'
    | '/admin/order-exports/'
    | '/admin/orders/'
    | '/admin/organization-merge/'
    | '/admin/organization-sync/'
    | '/admin/organizations/'
    | '/admin/price-correction/'
    | '/admin/products/'
    | '/admin/reporting-exports/'
    | '/admin/reports/'
    | '/admin/resolved-emails/'
    | '/admin/sessions/'
    | '/admin/supplier-reid/'
    | '/admin/sync-batches/'
    | '/admin/sync-diff/'
    | '/admin/sync-requests/'
    | '/admin/sync-result/'
    | '/admin/sync-send/'
    | '/admin/users/'
    | '/admin/workflows/'
    | '/order-action/$code/'
    | '/scheduled-order-action/$code/'
    | '/c/$orgId/$portalId/addresses'
    | '/c/$orgId/$portalId/basket'
    | '/c/$orgId/$portalId/custom-products'
    | '/c/$orgId/$portalId/custom-suppliers'
    | '/c/$orgId/$portalId/dashboard'
    | '/c/$orgId/$portalId/delivery-windows'
    | '/c/$orgId/$portalId/favourites'
    | '/c/$orgId/$portalId/my-account'
    | '/c/$orgId/$portalId/search'
    | '/c/$orgId/$portalId/settings'
    | '/c/$orgId/$portalId/users'
    | '/s/$orgId/$portalId/catalog'
    | '/s/$orgId/$portalId/delivery-windows'
    | '/s/$orgId/$portalId/my-account'
    | '/s/$orgId/$portalId/prices'
    | '/admin/organizations/$organizationId/'
    | '/c/$orgId/$portalId/'
    | '/s/$orgId/$portalId/'
    | '/c/$orgId/$portalId/auctions/$auctionId'
    | '/c/$orgId/$portalId/catalog/$categoryEcid'
    | '/c/$orgId/$portalId/orders/$orderId'
    | '/c/$orgId/$portalId/reports/$reportCode'
    | '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
    | '/c/$orgId/$portalId/shopping-list/$shoppingListId'
    | '/s/$orgId/$portalId/orders/$orderId'
    | '/s/$orgId/$portalId/products/$productId'
    | '/admin/organizations/$organizationId/auction-limits/'
    | '/c/$orgId/$portalId/articles/'
    | '/c/$orgId/$portalId/auctions/'
    | '/c/$orgId/$portalId/basket-savings/'
    | '/c/$orgId/$portalId/catalog/'
    | '/c/$orgId/$portalId/order-success/'
    | '/c/$orgId/$portalId/orders/'
    | '/c/$orgId/$portalId/reports/'
    | '/c/$orgId/$portalId/scheduled-orders/'
    | '/c/$orgId/$portalId/shopping-list/'
    | '/c/$orgId/$portalId/support/'
    | '/c/$orgId/$portalId/upcoming-goods/'
    | '/s/$orgId/$portalId/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  DemoPozvankaRoute: typeof DemoPozvankaRoute
  LoginRoute: typeof LoginRoute
  LostLoginRoute: typeof LostLoginRoute
  LostPasswordRoute: typeof LostPasswordRoute
  ProfileRoute: typeof ProfileRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminBlockedCategoriesRoute: typeof AdminBlockedCategoriesRoute
  AdminCatalogRoute: typeof AdminCatalogRoute
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminCategoryTreeRoute: typeof AdminCategoryTreeRoute
  AdminDemoInvitationsRoute: typeof AdminDemoInvitationsRoute
  AdminElasticRoute: typeof AdminElasticRoute
  AdminProductImagesRoute: typeof AdminProductImagesRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminSecurityGroupsRoute: typeof AdminSecurityGroupsRoute
  AdminTasksRoute: typeof AdminTasksRoute
  AdminTestRoute: typeof AdminTestRoute
  AdminIndexRoute: typeof AdminIndexRoute
  COrgIdPortalIdRouteRoute: typeof COrgIdPortalIdRouteRouteWithChildren
  SOrgIdPortalIdRouteRoute: typeof SOrgIdPortalIdRouteRouteWithChildren
  AdminArticlesArticleIdRoute: typeof AdminArticlesArticleIdRoute
  AdminAuctionsAuctionIdRoute: typeof AdminAuctionsAuctionIdRoute
  AdminCustomersCustomerIdRoute: typeof AdminCustomersCustomerIdRoute
  AdminOrdersOrderIdRoute: typeof AdminOrdersOrderIdRoute
  AdminProductsProductIdRoute: typeof AdminProductsProductIdRoute
  AdminSyncBatchesRequestIdRoute: typeof AdminSyncBatchesRequestIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminWorkflowsNameRoute: typeof AdminWorkflowsNameRoute
  OrderActionCodeApproveRoute: typeof OrderActionCodeApproveRoute
  OrderActionCodeRejectRoute: typeof OrderActionCodeRejectRoute
  ScheduledOrderActionCodeApproveRoute: typeof ScheduledOrderActionCodeApproveRoute
  ScheduledOrderActionCodeDispatchNowRoute: typeof ScheduledOrderActionCodeDispatchNowRoute
  ScheduledOrderActionCodeRejectRoute: typeof ScheduledOrderActionCodeRejectRoute
  AdminArticlesIndexRoute: typeof AdminArticlesIndexRoute
  AdminAuctionsIndexRoute: typeof AdminAuctionsIndexRoute
  AdminCartsIndexRoute: typeof AdminCartsIndexRoute
  AdminCatalogImportIndexRoute: typeof AdminCatalogImportIndexRoute
  AdminContractGroupsIndexRoute: typeof AdminContractGroupsIndexRoute
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute
  AdminDeliveryImportIndexRoute: typeof AdminDeliveryImportIndexRoute
  AdminDeliveryWindowsIndexRoute: typeof AdminDeliveryWindowsIndexRoute
  AdminEmailRequestsIndexRoute: typeof AdminEmailRequestsIndexRoute
  AdminEnvCheckIndexRoute: typeof AdminEnvCheckIndexRoute
  AdminEsQueryLogsIndexRoute: typeof AdminEsQueryLogsIndexRoute
  AdminImageImportIndexRoute: typeof AdminImageImportIndexRoute
  AdminInitialLoadIndexRoute: typeof AdminInitialLoadIndexRoute
  AdminInvoicingExportsIndexRoute: typeof AdminInvoicingExportsIndexRoute
  AdminNpAddressSyncIndexRoute: typeof AdminNpAddressSyncIndexRoute
  AdminNpLoadIndexRoute: typeof AdminNpLoadIndexRoute
  AdminNpUserSyncIndexRoute: typeof AdminNpUserSyncIndexRoute
  AdminOrderExportsIndexRoute: typeof AdminOrderExportsIndexRoute
  AdminOrdersIndexRoute: typeof AdminOrdersIndexRoute
  AdminOrganizationMergeIndexRoute: typeof AdminOrganizationMergeIndexRoute
  AdminOrganizationSyncIndexRoute: typeof AdminOrganizationSyncIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminPriceCorrectionIndexRoute: typeof AdminPriceCorrectionIndexRoute
  AdminProductsIndexRoute: typeof AdminProductsIndexRoute
  AdminReportingExportsIndexRoute: typeof AdminReportingExportsIndexRoute
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
  AdminResolvedEmailsIndexRoute: typeof AdminResolvedEmailsIndexRoute
  AdminSessionsIndexRoute: typeof AdminSessionsIndexRoute
  AdminSupplierReidIndexRoute: typeof AdminSupplierReidIndexRoute
  AdminSyncBatchesIndexRoute: typeof AdminSyncBatchesIndexRoute
  AdminSyncDiffIndexRoute: typeof AdminSyncDiffIndexRoute
  AdminSyncRequestsIndexRoute: typeof AdminSyncRequestsIndexRoute
  AdminSyncResultIndexRoute: typeof AdminSyncResultIndexRoute
  AdminSyncSendIndexRoute: typeof AdminSyncSendIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminWorkflowsIndexRoute: typeof AdminWorkflowsIndexRoute
  OrderActionCodeIndexRoute: typeof OrderActionCodeIndexRoute
  ScheduledOrderActionCodeIndexRoute: typeof ScheduledOrderActionCodeIndexRoute
  AdminOrganizationsOrganizationIdIndexRoute: typeof AdminOrganizationsOrganizationIdIndexRoute
  AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute: typeof AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lost-password': {
      id: '/lost-password'
      path: '/lost-password'
      fullPath: '/lost-password'
      preLoaderRoute: typeof LostPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lost-login': {
      id: '/lost-login'
      path: '/lost-login'
      fullPath: '/lost-login'
      preLoaderRoute: typeof LostLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo-pozvanka': {
      id: '/demo-pozvanka'
      path: '/demo-pozvanka'
      fullPath: '/demo-pozvanka'
      preLoaderRoute: typeof DemoPozvankaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/test': {
      id: '/admin/test'
      path: '/admin/test'
      fullPath: '/admin/test'
      preLoaderRoute: typeof AdminTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tasks': {
      id: '/admin/tasks'
      path: '/admin/tasks'
      fullPath: '/admin/tasks'
      preLoaderRoute: typeof AdminTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/security-groups': {
      id: '/admin/security-groups'
      path: '/admin/security-groups'
      fullPath: '/admin/security-groups'
      preLoaderRoute: typeof AdminSecurityGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/product-images': {
      id: '/admin/product-images'
      path: '/admin/product-images'
      fullPath: '/admin/product-images'
      preLoaderRoute: typeof AdminProductImagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/elastic': {
      id: '/admin/elastic'
      path: '/admin/elastic'
      fullPath: '/admin/elastic'
      preLoaderRoute: typeof AdminElasticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/demo-invitations': {
      id: '/admin/demo-invitations'
      path: '/admin/demo-invitations'
      fullPath: '/admin/demo-invitations'
      preLoaderRoute: typeof AdminDemoInvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/category-tree': {
      id: '/admin/category-tree'
      path: '/admin/category-tree'
      fullPath: '/admin/category-tree'
      preLoaderRoute: typeof AdminCategoryTreeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/categories': {
      id: '/admin/categories'
      path: '/admin/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/catalog': {
      id: '/admin/catalog'
      path: '/admin/catalog'
      fullPath: '/admin/catalog'
      preLoaderRoute: typeof AdminCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/blocked-categories': {
      id: '/admin/blocked-categories'
      path: '/admin/blocked-categories'
      fullPath: '/admin/blocked-categories'
      preLoaderRoute: typeof AdminBlockedCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled-order-action/$code/': {
      id: '/scheduled-order-action/$code/'
      path: '/scheduled-order-action/$code'
      fullPath: '/scheduled-order-action/$code'
      preLoaderRoute: typeof ScheduledOrderActionCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-action/$code/': {
      id: '/order-action/$code/'
      path: '/order-action/$code'
      fullPath: '/order-action/$code'
      preLoaderRoute: typeof OrderActionCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workflows/': {
      id: '/admin/workflows/'
      path: '/admin/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AdminWorkflowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-send/': {
      id: '/admin/sync-send/'
      path: '/admin/sync-send'
      fullPath: '/admin/sync-send'
      preLoaderRoute: typeof AdminSyncSendIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-result/': {
      id: '/admin/sync-result/'
      path: '/admin/sync-result'
      fullPath: '/admin/sync-result'
      preLoaderRoute: typeof AdminSyncResultIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-requests/': {
      id: '/admin/sync-requests/'
      path: '/admin/sync-requests'
      fullPath: '/admin/sync-requests'
      preLoaderRoute: typeof AdminSyncRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-diff/': {
      id: '/admin/sync-diff/'
      path: '/admin/sync-diff'
      fullPath: '/admin/sync-diff'
      preLoaderRoute: typeof AdminSyncDiffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-batches/': {
      id: '/admin/sync-batches/'
      path: '/admin/sync-batches'
      fullPath: '/admin/sync-batches'
      preLoaderRoute: typeof AdminSyncBatchesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/supplier-reid/': {
      id: '/admin/supplier-reid/'
      path: '/admin/supplier-reid'
      fullPath: '/admin/supplier-reid'
      preLoaderRoute: typeof AdminSupplierReidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sessions/': {
      id: '/admin/sessions/'
      path: '/admin/sessions'
      fullPath: '/admin/sessions'
      preLoaderRoute: typeof AdminSessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/resolved-emails/': {
      id: '/admin/resolved-emails/'
      path: '/admin/resolved-emails'
      fullPath: '/admin/resolved-emails'
      preLoaderRoute: typeof AdminResolvedEmailsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports/': {
      id: '/admin/reports/'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reporting-exports/': {
      id: '/admin/reporting-exports/'
      path: '/admin/reporting-exports'
      fullPath: '/admin/reporting-exports'
      preLoaderRoute: typeof AdminReportingExportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/': {
      id: '/admin/products/'
      path: '/admin/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/price-correction/': {
      id: '/admin/price-correction/'
      path: '/admin/price-correction'
      fullPath: '/admin/price-correction'
      preLoaderRoute: typeof AdminPriceCorrectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organization-sync/': {
      id: '/admin/organization-sync/'
      path: '/admin/organization-sync'
      fullPath: '/admin/organization-sync'
      preLoaderRoute: typeof AdminOrganizationSyncIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organization-merge/': {
      id: '/admin/organization-merge/'
      path: '/admin/organization-merge'
      fullPath: '/admin/organization-merge'
      preLoaderRoute: typeof AdminOrganizationMergeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/orders/': {
      id: '/admin/orders/'
      path: '/admin/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AdminOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/order-exports/': {
      id: '/admin/order-exports/'
      path: '/admin/order-exports'
      fullPath: '/admin/order-exports'
      preLoaderRoute: typeof AdminOrderExportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/np-user-sync/': {
      id: '/admin/np-user-sync/'
      path: '/admin/np-user-sync'
      fullPath: '/admin/np-user-sync'
      preLoaderRoute: typeof AdminNpUserSyncIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/np-load/': {
      id: '/admin/np-load/'
      path: '/admin/np-load'
      fullPath: '/admin/np-load'
      preLoaderRoute: typeof AdminNpLoadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/np-address-sync/': {
      id: '/admin/np-address-sync/'
      path: '/admin/np-address-sync'
      fullPath: '/admin/np-address-sync'
      preLoaderRoute: typeof AdminNpAddressSyncIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/invoicing-exports/': {
      id: '/admin/invoicing-exports/'
      path: '/admin/invoicing-exports'
      fullPath: '/admin/invoicing-exports'
      preLoaderRoute: typeof AdminInvoicingExportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/initial-load/': {
      id: '/admin/initial-load/'
      path: '/admin/initial-load'
      fullPath: '/admin/initial-load'
      preLoaderRoute: typeof AdminInitialLoadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/image-import/': {
      id: '/admin/image-import/'
      path: '/admin/image-import'
      fullPath: '/admin/image-import'
      preLoaderRoute: typeof AdminImageImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/es-query-logs/': {
      id: '/admin/es-query-logs/'
      path: '/admin/es-query-logs'
      fullPath: '/admin/es-query-logs'
      preLoaderRoute: typeof AdminEsQueryLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/env-check/': {
      id: '/admin/env-check/'
      path: '/admin/env-check'
      fullPath: '/admin/env-check'
      preLoaderRoute: typeof AdminEnvCheckIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email-requests/': {
      id: '/admin/email-requests/'
      path: '/admin/email-requests'
      fullPath: '/admin/email-requests'
      preLoaderRoute: typeof AdminEmailRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/delivery-windows/': {
      id: '/admin/delivery-windows/'
      path: '/admin/delivery-windows'
      fullPath: '/admin/delivery-windows'
      preLoaderRoute: typeof AdminDeliveryWindowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/delivery-import/': {
      id: '/admin/delivery-import/'
      path: '/admin/delivery-import'
      fullPath: '/admin/delivery-import'
      preLoaderRoute: typeof AdminDeliveryImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/admin/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/contract-groups/': {
      id: '/admin/contract-groups/'
      path: '/admin/contract-groups'
      fullPath: '/admin/contract-groups'
      preLoaderRoute: typeof AdminContractGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/catalog-import/': {
      id: '/admin/catalog-import/'
      path: '/admin/catalog-import'
      fullPath: '/admin/catalog-import'
      preLoaderRoute: typeof AdminCatalogImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/carts/': {
      id: '/admin/carts/'
      path: '/admin/carts'
      fullPath: '/admin/carts'
      preLoaderRoute: typeof AdminCartsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/auctions/': {
      id: '/admin/auctions/'
      path: '/admin/auctions'
      fullPath: '/admin/auctions'
      preLoaderRoute: typeof AdminAuctionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/articles/': {
      id: '/admin/articles/'
      path: '/admin/articles'
      fullPath: '/admin/articles'
      preLoaderRoute: typeof AdminArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled-order-action/$code/reject': {
      id: '/scheduled-order-action/$code/reject'
      path: '/scheduled-order-action/$code/reject'
      fullPath: '/scheduled-order-action/$code/reject'
      preLoaderRoute: typeof ScheduledOrderActionCodeRejectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled-order-action/$code/dispatch-now': {
      id: '/scheduled-order-action/$code/dispatch-now'
      path: '/scheduled-order-action/$code/dispatch-now'
      fullPath: '/scheduled-order-action/$code/dispatch-now'
      preLoaderRoute: typeof ScheduledOrderActionCodeDispatchNowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduled-order-action/$code/approve': {
      id: '/scheduled-order-action/$code/approve'
      path: '/scheduled-order-action/$code/approve'
      fullPath: '/scheduled-order-action/$code/approve'
      preLoaderRoute: typeof ScheduledOrderActionCodeApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-action/$code/reject': {
      id: '/order-action/$code/reject'
      path: '/order-action/$code/reject'
      fullPath: '/order-action/$code/reject'
      preLoaderRoute: typeof OrderActionCodeRejectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-action/$code/approve': {
      id: '/order-action/$code/approve'
      path: '/order-action/$code/approve'
      fullPath: '/order-action/$code/approve'
      preLoaderRoute: typeof OrderActionCodeApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workflows/$name': {
      id: '/admin/workflows/$name'
      path: '/admin/workflows/$name'
      fullPath: '/admin/workflows/$name'
      preLoaderRoute: typeof AdminWorkflowsNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync-batches/$requestId': {
      id: '/admin/sync-batches/$requestId'
      path: '/admin/sync-batches/$requestId'
      fullPath: '/admin/sync-batches/$requestId'
      preLoaderRoute: typeof AdminSyncBatchesRequestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/$productId': {
      id: '/admin/products/$productId'
      path: '/admin/products/$productId'
      fullPath: '/admin/products/$productId'
      preLoaderRoute: typeof AdminProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/orders/$orderId': {
      id: '/admin/orders/$orderId'
      path: '/admin/orders/$orderId'
      fullPath: '/admin/orders/$orderId'
      preLoaderRoute: typeof AdminOrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/customers/$customerId': {
      id: '/admin/customers/$customerId'
      path: '/admin/customers/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof AdminCustomersCustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/auctions/$auctionId': {
      id: '/admin/auctions/$auctionId'
      path: '/admin/auctions/$auctionId'
      fullPath: '/admin/auctions/$auctionId'
      preLoaderRoute: typeof AdminAuctionsAuctionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/articles/$articleId': {
      id: '/admin/articles/$articleId'
      path: '/admin/articles/$articleId'
      fullPath: '/admin/articles/$articleId'
      preLoaderRoute: typeof AdminArticlesArticleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$orgId/$portalId': {
      id: '/s/$orgId/$portalId'
      path: '/s/$orgId/$portalId'
      fullPath: '/s/$orgId/$portalId'
      preLoaderRoute: typeof SOrgIdPortalIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$orgId/$portalId': {
      id: '/c/$orgId/$portalId'
      path: '/c/$orgId/$portalId'
      fullPath: '/c/$orgId/$portalId'
      preLoaderRoute: typeof COrgIdPortalIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$orgId/$portalId/': {
      id: '/s/$orgId/$portalId/'
      path: '/'
      fullPath: '/s/$orgId/$portalId/'
      preLoaderRoute: typeof SOrgIdPortalIdIndexRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/': {
      id: '/c/$orgId/$portalId/'
      path: '/'
      fullPath: '/c/$orgId/$portalId/'
      preLoaderRoute: typeof COrgIdPortalIdIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/admin/organizations/$organizationId/': {
      id: '/admin/organizations/$organizationId/'
      path: '/admin/organizations/$organizationId'
      fullPath: '/admin/organizations/$organizationId'
      preLoaderRoute: typeof AdminOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$orgId/$portalId/prices': {
      id: '/s/$orgId/$portalId/prices'
      path: '/prices'
      fullPath: '/s/$orgId/$portalId/prices'
      preLoaderRoute: typeof SOrgIdPortalIdPricesRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/s/$orgId/$portalId/my-account': {
      id: '/s/$orgId/$portalId/my-account'
      path: '/my-account'
      fullPath: '/s/$orgId/$portalId/my-account'
      preLoaderRoute: typeof SOrgIdPortalIdMyAccountRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/s/$orgId/$portalId/delivery-windows': {
      id: '/s/$orgId/$portalId/delivery-windows'
      path: '/delivery-windows'
      fullPath: '/s/$orgId/$portalId/delivery-windows'
      preLoaderRoute: typeof SOrgIdPortalIdDeliveryWindowsRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/s/$orgId/$portalId/catalog': {
      id: '/s/$orgId/$portalId/catalog'
      path: '/catalog'
      fullPath: '/s/$orgId/$portalId/catalog'
      preLoaderRoute: typeof SOrgIdPortalIdCatalogRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/users': {
      id: '/c/$orgId/$portalId/users'
      path: '/users'
      fullPath: '/c/$orgId/$portalId/users'
      preLoaderRoute: typeof COrgIdPortalIdUsersRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/settings': {
      id: '/c/$orgId/$portalId/settings'
      path: '/settings'
      fullPath: '/c/$orgId/$portalId/settings'
      preLoaderRoute: typeof COrgIdPortalIdSettingsRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/search': {
      id: '/c/$orgId/$portalId/search'
      path: '/search'
      fullPath: '/c/$orgId/$portalId/search'
      preLoaderRoute: typeof COrgIdPortalIdSearchRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/my-account': {
      id: '/c/$orgId/$portalId/my-account'
      path: '/my-account'
      fullPath: '/c/$orgId/$portalId/my-account'
      preLoaderRoute: typeof COrgIdPortalIdMyAccountRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/favourites': {
      id: '/c/$orgId/$portalId/favourites'
      path: '/favourites'
      fullPath: '/c/$orgId/$portalId/favourites'
      preLoaderRoute: typeof COrgIdPortalIdFavouritesRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/delivery-windows': {
      id: '/c/$orgId/$portalId/delivery-windows'
      path: '/delivery-windows'
      fullPath: '/c/$orgId/$portalId/delivery-windows'
      preLoaderRoute: typeof COrgIdPortalIdDeliveryWindowsRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/dashboard': {
      id: '/c/$orgId/$portalId/dashboard'
      path: '/dashboard'
      fullPath: '/c/$orgId/$portalId/dashboard'
      preLoaderRoute: typeof COrgIdPortalIdDashboardRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/custom-suppliers': {
      id: '/c/$orgId/$portalId/custom-suppliers'
      path: '/custom-suppliers'
      fullPath: '/c/$orgId/$portalId/custom-suppliers'
      preLoaderRoute: typeof COrgIdPortalIdCustomSuppliersRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/custom-products': {
      id: '/c/$orgId/$portalId/custom-products'
      path: '/custom-products'
      fullPath: '/c/$orgId/$portalId/custom-products'
      preLoaderRoute: typeof COrgIdPortalIdCustomProductsRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/basket': {
      id: '/c/$orgId/$portalId/basket'
      path: '/basket'
      fullPath: '/c/$orgId/$portalId/basket'
      preLoaderRoute: typeof COrgIdPortalIdBasketRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/addresses': {
      id: '/c/$orgId/$portalId/addresses'
      path: '/addresses'
      fullPath: '/c/$orgId/$portalId/addresses'
      preLoaderRoute: typeof COrgIdPortalIdAddressesRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/s/$orgId/$portalId/orders/': {
      id: '/s/$orgId/$portalId/orders/'
      path: '/orders'
      fullPath: '/s/$orgId/$portalId/orders'
      preLoaderRoute: typeof SOrgIdPortalIdOrdersIndexRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/upcoming-goods/': {
      id: '/c/$orgId/$portalId/upcoming-goods/'
      path: '/upcoming-goods'
      fullPath: '/c/$orgId/$portalId/upcoming-goods'
      preLoaderRoute: typeof COrgIdPortalIdUpcomingGoodsIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/support/': {
      id: '/c/$orgId/$portalId/support/'
      path: '/support'
      fullPath: '/c/$orgId/$portalId/support'
      preLoaderRoute: typeof COrgIdPortalIdSupportIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/shopping-list/': {
      id: '/c/$orgId/$portalId/shopping-list/'
      path: '/shopping-list'
      fullPath: '/c/$orgId/$portalId/shopping-list'
      preLoaderRoute: typeof COrgIdPortalIdShoppingListIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/scheduled-orders/': {
      id: '/c/$orgId/$portalId/scheduled-orders/'
      path: '/scheduled-orders'
      fullPath: '/c/$orgId/$portalId/scheduled-orders'
      preLoaderRoute: typeof COrgIdPortalIdScheduledOrdersIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/reports/': {
      id: '/c/$orgId/$portalId/reports/'
      path: '/reports'
      fullPath: '/c/$orgId/$portalId/reports'
      preLoaderRoute: typeof COrgIdPortalIdReportsIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/orders/': {
      id: '/c/$orgId/$portalId/orders/'
      path: '/orders'
      fullPath: '/c/$orgId/$portalId/orders'
      preLoaderRoute: typeof COrgIdPortalIdOrdersIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/order-success/': {
      id: '/c/$orgId/$portalId/order-success/'
      path: '/order-success'
      fullPath: '/c/$orgId/$portalId/order-success'
      preLoaderRoute: typeof COrgIdPortalIdOrderSuccessIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/catalog/': {
      id: '/c/$orgId/$portalId/catalog/'
      path: '/catalog'
      fullPath: '/c/$orgId/$portalId/catalog'
      preLoaderRoute: typeof COrgIdPortalIdCatalogIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/basket-savings/': {
      id: '/c/$orgId/$portalId/basket-savings/'
      path: '/basket-savings'
      fullPath: '/c/$orgId/$portalId/basket-savings'
      preLoaderRoute: typeof COrgIdPortalIdBasketSavingsIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/auctions/': {
      id: '/c/$orgId/$portalId/auctions/'
      path: '/auctions'
      fullPath: '/c/$orgId/$portalId/auctions'
      preLoaderRoute: typeof COrgIdPortalIdAuctionsIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/articles/': {
      id: '/c/$orgId/$portalId/articles/'
      path: '/articles'
      fullPath: '/c/$orgId/$portalId/articles'
      preLoaderRoute: typeof COrgIdPortalIdArticlesIndexRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/admin/organizations/$organizationId/auction-limits/': {
      id: '/admin/organizations/$organizationId/auction-limits/'
      path: '/admin/organizations/$organizationId/auction-limits'
      fullPath: '/admin/organizations/$organizationId/auction-limits'
      preLoaderRoute: typeof AdminOrganizationsOrganizationIdAuctionLimitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$orgId/$portalId/products/$productId': {
      id: '/s/$orgId/$portalId/products/$productId'
      path: '/products/$productId'
      fullPath: '/s/$orgId/$portalId/products/$productId'
      preLoaderRoute: typeof SOrgIdPortalIdProductsProductIdRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/s/$orgId/$portalId/orders/$orderId': {
      id: '/s/$orgId/$portalId/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/s/$orgId/$portalId/orders/$orderId'
      preLoaderRoute: typeof SOrgIdPortalIdOrdersOrderIdRouteImport
      parentRoute: typeof SOrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/shopping-list/$shoppingListId': {
      id: '/c/$orgId/$portalId/shopping-list/$shoppingListId'
      path: '/shopping-list/$shoppingListId'
      fullPath: '/c/$orgId/$portalId/shopping-list/$shoppingListId'
      preLoaderRoute: typeof COrgIdPortalIdShoppingListShoppingListIdRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId': {
      id: '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
      path: '/scheduled-orders/$scheduledOrderId'
      fullPath: '/c/$orgId/$portalId/scheduled-orders/$scheduledOrderId'
      preLoaderRoute: typeof COrgIdPortalIdScheduledOrdersScheduledOrderIdRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/reports/$reportCode': {
      id: '/c/$orgId/$portalId/reports/$reportCode'
      path: '/reports/$reportCode'
      fullPath: '/c/$orgId/$portalId/reports/$reportCode'
      preLoaderRoute: typeof COrgIdPortalIdReportsReportCodeRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/orders/$orderId': {
      id: '/c/$orgId/$portalId/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/c/$orgId/$portalId/orders/$orderId'
      preLoaderRoute: typeof COrgIdPortalIdOrdersOrderIdRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/catalog/$categoryEcid': {
      id: '/c/$orgId/$portalId/catalog/$categoryEcid'
      path: '/catalog/$categoryEcid'
      fullPath: '/c/$orgId/$portalId/catalog/$categoryEcid'
      preLoaderRoute: typeof COrgIdPortalIdCatalogCategoryEcidRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
    '/c/$orgId/$portalId/auctions/$auctionId': {
      id: '/c/$orgId/$portalId/auctions/$auctionId'
      path: '/auctions/$auctionId'
      fullPath: '/c/$orgId/$portalId/auctions/$auctionId'
      preLoaderRoute: typeof COrgIdPortalIdAuctionsAuctionIdRouteImport
      parentRoute: typeof COrgIdPortalIdRouteRoute
    }
  }
}

interface COrgIdPortalIdRouteRouteChildren {
  COrgIdPortalIdAddressesRoute: typeof COrgIdPortalIdAddressesRoute
  COrgIdPortalIdBasketRoute: typeof COrgIdPortalIdBasketRoute
  COrgIdPortalIdCustomProductsRoute: typeof COrgIdPortalIdCustomProductsRoute
  COrgIdPortalIdCustomSuppliersRoute: typeof COrgIdPortalIdCustomSuppliersRoute
  COrgIdPortalIdDashboardRoute: typeof COrgIdPortalIdDashboardRoute
  COrgIdPortalIdDeliveryWindowsRoute: typeof COrgIdPortalIdDeliveryWindowsRoute
  COrgIdPortalIdFavouritesRoute: typeof COrgIdPortalIdFavouritesRoute
  COrgIdPortalIdMyAccountRoute: typeof COrgIdPortalIdMyAccountRoute
  COrgIdPortalIdSearchRoute: typeof COrgIdPortalIdSearchRoute
  COrgIdPortalIdSettingsRoute: typeof COrgIdPortalIdSettingsRoute
  COrgIdPortalIdUsersRoute: typeof COrgIdPortalIdUsersRoute
  COrgIdPortalIdIndexRoute: typeof COrgIdPortalIdIndexRoute
  COrgIdPortalIdAuctionsAuctionIdRoute: typeof COrgIdPortalIdAuctionsAuctionIdRoute
  COrgIdPortalIdCatalogCategoryEcidRoute: typeof COrgIdPortalIdCatalogCategoryEcidRoute
  COrgIdPortalIdOrdersOrderIdRoute: typeof COrgIdPortalIdOrdersOrderIdRoute
  COrgIdPortalIdReportsReportCodeRoute: typeof COrgIdPortalIdReportsReportCodeRoute
  COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute: typeof COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute
  COrgIdPortalIdShoppingListShoppingListIdRoute: typeof COrgIdPortalIdShoppingListShoppingListIdRoute
  COrgIdPortalIdArticlesIndexRoute: typeof COrgIdPortalIdArticlesIndexRoute
  COrgIdPortalIdAuctionsIndexRoute: typeof COrgIdPortalIdAuctionsIndexRoute
  COrgIdPortalIdBasketSavingsIndexRoute: typeof COrgIdPortalIdBasketSavingsIndexRoute
  COrgIdPortalIdCatalogIndexRoute: typeof COrgIdPortalIdCatalogIndexRoute
  COrgIdPortalIdOrderSuccessIndexRoute: typeof COrgIdPortalIdOrderSuccessIndexRoute
  COrgIdPortalIdOrdersIndexRoute: typeof COrgIdPortalIdOrdersIndexRoute
  COrgIdPortalIdReportsIndexRoute: typeof COrgIdPortalIdReportsIndexRoute
  COrgIdPortalIdScheduledOrdersIndexRoute: typeof COrgIdPortalIdScheduledOrdersIndexRoute
  COrgIdPortalIdShoppingListIndexRoute: typeof COrgIdPortalIdShoppingListIndexRoute
  COrgIdPortalIdSupportIndexRoute: typeof COrgIdPortalIdSupportIndexRoute
  COrgIdPortalIdUpcomingGoodsIndexRoute: typeof COrgIdPortalIdUpcomingGoodsIndexRoute
}

const COrgIdPortalIdRouteRouteChildren: COrgIdPortalIdRouteRouteChildren = {
  COrgIdPortalIdAddressesRoute: COrgIdPortalIdAddressesRoute,
  COrgIdPortalIdBasketRoute: COrgIdPortalIdBasketRoute,
  COrgIdPortalIdCustomProductsRoute: COrgIdPortalIdCustomProductsRoute,
  COrgIdPortalIdCustomSuppliersRoute: COrgIdPortalIdCustomSuppliersRoute,
  COrgIdPortalIdDashboardRoute: COrgIdPortalIdDashboardRoute,
  COrgIdPortalIdDeliveryWindowsRoute: COrgIdPortalIdDeliveryWindowsRoute,
  COrgIdPortalIdFavouritesRoute: COrgIdPortalIdFavouritesRoute,
  COrgIdPortalIdMyAccountRoute: COrgIdPortalIdMyAccountRoute,
  COrgIdPortalIdSearchRoute: COrgIdPortalIdSearchRoute,
  COrgIdPortalIdSettingsRoute: COrgIdPortalIdSettingsRoute,
  COrgIdPortalIdUsersRoute: COrgIdPortalIdUsersRoute,
  COrgIdPortalIdIndexRoute: COrgIdPortalIdIndexRoute,
  COrgIdPortalIdAuctionsAuctionIdRoute: COrgIdPortalIdAuctionsAuctionIdRoute,
  COrgIdPortalIdCatalogCategoryEcidRoute:
    COrgIdPortalIdCatalogCategoryEcidRoute,
  COrgIdPortalIdOrdersOrderIdRoute: COrgIdPortalIdOrdersOrderIdRoute,
  COrgIdPortalIdReportsReportCodeRoute: COrgIdPortalIdReportsReportCodeRoute,
  COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute:
    COrgIdPortalIdScheduledOrdersScheduledOrderIdRoute,
  COrgIdPortalIdShoppingListShoppingListIdRoute:
    COrgIdPortalIdShoppingListShoppingListIdRoute,
  COrgIdPortalIdArticlesIndexRoute: COrgIdPortalIdArticlesIndexRoute,
  COrgIdPortalIdAuctionsIndexRoute: COrgIdPortalIdAuctionsIndexRoute,
  COrgIdPortalIdBasketSavingsIndexRoute: COrgIdPortalIdBasketSavingsIndexRoute,
  COrgIdPortalIdCatalogIndexRoute: COrgIdPortalIdCatalogIndexRoute,
  COrgIdPortalIdOrderSuccessIndexRoute: COrgIdPortalIdOrderSuccessIndexRoute,
  COrgIdPortalIdOrdersIndexRoute: COrgIdPortalIdOrdersIndexRoute,
  COrgIdPortalIdReportsIndexRoute: COrgIdPortalIdReportsIndexRoute,
  COrgIdPortalIdScheduledOrdersIndexRoute:
    COrgIdPortalIdScheduledOrdersIndexRoute,
  COrgIdPortalIdShoppingListIndexRoute: COrgIdPortalIdShoppingListIndexRoute,
  COrgIdPortalIdSupportIndexRoute: COrgIdPortalIdSupportIndexRoute,
  COrgIdPortalIdUpcomingGoodsIndexRoute: COrgIdPortalIdUpcomingGoodsIndexRoute,
}

const COrgIdPortalIdRouteRouteWithChildren =
  COrgIdPortalIdRouteRoute._addFileChildren(COrgIdPortalIdRouteRouteChildren)

interface SOrgIdPortalIdRouteRouteChildren {
  SOrgIdPortalIdCatalogRoute: typeof SOrgIdPortalIdCatalogRoute
  SOrgIdPortalIdDeliveryWindowsRoute: typeof SOrgIdPortalIdDeliveryWindowsRoute
  SOrgIdPortalIdMyAccountRoute: typeof SOrgIdPortalIdMyAccountRoute
  SOrgIdPortalIdPricesRoute: typeof SOrgIdPortalIdPricesRoute
  SOrgIdPortalIdIndexRoute: typeof SOrgIdPortalIdIndexRoute
  SOrgIdPortalIdOrdersOrderIdRoute: typeof SOrgIdPortalIdOrdersOrderIdRoute
  SOrgIdPortalIdProductsProductIdRoute: typeof SOrgIdPortalIdProductsProductIdRoute
  SOrgIdPortalIdOrdersIndexRoute: typeof SOrgIdPortalIdOrdersIndexRoute
}

const SOrgIdPortalIdRouteRouteChildren: SOrgIdPortalIdRouteRouteChildren = {
  SOrgIdPortalIdCatalogRoute: SOrgIdPortalIdCatalogRoute,
  SOrgIdPortalIdDeliveryWindowsRoute: SOrgIdPortalIdDeliveryWindowsRoute,
  SOrgIdPortalIdMyAccountRoute: SOrgIdPortalIdMyAccountRoute,
  SOrgIdPortalIdPricesRoute: SOrgIdPortalIdPricesRoute,
  SOrgIdPortalIdIndexRoute: SOrgIdPortalIdIndexRoute,
  SOrgIdPortalIdOrdersOrderIdRoute: SOrgIdPortalIdOrdersOrderIdRoute,
  SOrgIdPortalIdProductsProductIdRoute: SOrgIdPortalIdProductsProductIdRoute,
  SOrgIdPortalIdOrdersIndexRoute: SOrgIdPortalIdOrdersIndexRoute,
}

const SOrgIdPortalIdRouteRouteWithChildren =
  SOrgIdPortalIdRouteRoute._addFileChildren(SOrgIdPortalIdRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  DemoPozvankaRoute: DemoPozvankaRoute,
  LoginRoute: LoginRoute,
  LostLoginRoute: LostLoginRoute,
  LostPasswordRoute: LostPasswordRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminBlockedCategoriesRoute: AdminBlockedCategoriesRoute,
  AdminCatalogRoute: AdminCatalogRoute,
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminCategoryTreeRoute: AdminCategoryTreeRoute,
  AdminDemoInvitationsRoute: AdminDemoInvitationsRoute,
  AdminElasticRoute: AdminElasticRoute,
  AdminProductImagesRoute: AdminProductImagesRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminSecurityGroupsRoute: AdminSecurityGroupsRoute,
  AdminTasksRoute: AdminTasksRoute,
  AdminTestRoute: AdminTestRoute,
  AdminIndexRoute: AdminIndexRoute,
  COrgIdPortalIdRouteRoute: COrgIdPortalIdRouteRouteWithChildren,
  SOrgIdPortalIdRouteRoute: SOrgIdPortalIdRouteRouteWithChildren,
  AdminArticlesArticleIdRoute: AdminArticlesArticleIdRoute,
  AdminAuctionsAuctionIdRoute: AdminAuctionsAuctionIdRoute,
  AdminCustomersCustomerIdRoute: AdminCustomersCustomerIdRoute,
  AdminOrdersOrderIdRoute: AdminOrdersOrderIdRoute,
  AdminProductsProductIdRoute: AdminProductsProductIdRoute,
  AdminSyncBatchesRequestIdRoute: AdminSyncBatchesRequestIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminWorkflowsNameRoute: AdminWorkflowsNameRoute,
  OrderActionCodeApproveRoute: OrderActionCodeApproveRoute,
  OrderActionCodeRejectRoute: OrderActionCodeRejectRoute,
  ScheduledOrderActionCodeApproveRoute: ScheduledOrderActionCodeApproveRoute,
  ScheduledOrderActionCodeDispatchNowRoute:
    ScheduledOrderActionCodeDispatchNowRoute,
  ScheduledOrderActionCodeRejectRoute: ScheduledOrderActionCodeRejectRoute,
  AdminArticlesIndexRoute: AdminArticlesIndexRoute,
  AdminAuctionsIndexRoute: AdminAuctionsIndexRoute,
  AdminCartsIndexRoute: AdminCartsIndexRoute,
  AdminCatalogImportIndexRoute: AdminCatalogImportIndexRoute,
  AdminContractGroupsIndexRoute: AdminContractGroupsIndexRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
  AdminDeliveryImportIndexRoute: AdminDeliveryImportIndexRoute,
  AdminDeliveryWindowsIndexRoute: AdminDeliveryWindowsIndexRoute,
  AdminEmailRequestsIndexRoute: AdminEmailRequestsIndexRoute,
  AdminEnvCheckIndexRoute: AdminEnvCheckIndexRoute,
  AdminEsQueryLogsIndexRoute: AdminEsQueryLogsIndexRoute,
  AdminImageImportIndexRoute: AdminImageImportIndexRoute,
  AdminInitialLoadIndexRoute: AdminInitialLoadIndexRoute,
  AdminInvoicingExportsIndexRoute: AdminInvoicingExportsIndexRoute,
  AdminNpAddressSyncIndexRoute: AdminNpAddressSyncIndexRoute,
  AdminNpLoadIndexRoute: AdminNpLoadIndexRoute,
  AdminNpUserSyncIndexRoute: AdminNpUserSyncIndexRoute,
  AdminOrderExportsIndexRoute: AdminOrderExportsIndexRoute,
  AdminOrdersIndexRoute: AdminOrdersIndexRoute,
  AdminOrganizationMergeIndexRoute: AdminOrganizationMergeIndexRoute,
  AdminOrganizationSyncIndexRoute: AdminOrganizationSyncIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminPriceCorrectionIndexRoute: AdminPriceCorrectionIndexRoute,
  AdminProductsIndexRoute: AdminProductsIndexRoute,
  AdminReportingExportsIndexRoute: AdminReportingExportsIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminResolvedEmailsIndexRoute: AdminResolvedEmailsIndexRoute,
  AdminSessionsIndexRoute: AdminSessionsIndexRoute,
  AdminSupplierReidIndexRoute: AdminSupplierReidIndexRoute,
  AdminSyncBatchesIndexRoute: AdminSyncBatchesIndexRoute,
  AdminSyncDiffIndexRoute: AdminSyncDiffIndexRoute,
  AdminSyncRequestsIndexRoute: AdminSyncRequestsIndexRoute,
  AdminSyncResultIndexRoute: AdminSyncResultIndexRoute,
  AdminSyncSendIndexRoute: AdminSyncSendIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminWorkflowsIndexRoute: AdminWorkflowsIndexRoute,
  OrderActionCodeIndexRoute: OrderActionCodeIndexRoute,
  ScheduledOrderActionCodeIndexRoute: ScheduledOrderActionCodeIndexRoute,
  AdminOrganizationsOrganizationIdIndexRoute:
    AdminOrganizationsOrganizationIdIndexRoute,
  AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute:
    AdminOrganizationsOrganizationIdAuctionLimitsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
